// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AccountsApiDiscoveryGetAuthenticationMethodsData, AccountsApiDiscoveryGetAuthenticationMethodsErrors, AccountsApiDiscoveryGetAuthenticationMethodsResponses, AccountsApiLegacyGoogleLoginData, AccountsApiLegacyGoogleLoginErrors, AccountsApiLegacyGoogleLoginResponses, AccountsApiLegacyLogoutData, AccountsApiLegacyLogoutResponses, AccountsApiOtpRequestData, AccountsApiOtpRequestErrors, AccountsApiOtpRequestResponses, AccountsApiOtpVerifyData, AccountsApiOtpVerifyErrors, AccountsApiOtpVerifyResponses, AccountsApiProfileGetCurrentUserData, AccountsApiProfileGetCurrentUserErrors, AccountsApiProfileGetCurrentUserResponses, AccountsApiSessionsRefreshData, AccountsApiSessionsRefreshErrors, AccountsApiSessionsRefreshResponses, AccountsApiSessionsSessionLogoutData, AccountsApiSessionsSessionLogoutErrors, AccountsApiSessionsSessionLogoutResponses, AccountsApiSsoExchangeData, AccountsApiSsoExchangeErrors, AccountsApiSsoExchangeResponses, CategoriesApiCategoryStatsData, CategoriesApiCategoryStatsResponses, CategoriesApiCreateCategoryData, CategoriesApiCreateCategoryErrors, CategoriesApiCreateCategoryResponses, CategoriesApiDeleteCategoryData, CategoriesApiDeleteCategoryErrors, CategoriesApiDeleteCategoryResponses, CategoriesApiGetCategoryData, CategoriesApiGetCategoryResponses, CategoriesApiListCategoriesData, CategoriesApiListCategoriesResponses, CategoriesApiUpdateCategoryData, CategoriesApiUpdateCategoryErrors, CategoriesApiUpdateCategoryResponses, ComplianceApiBulkCompleteProductActionsData, ComplianceApiBulkCompleteProductActionsErrors, ComplianceApiBulkCompleteProductActionsResponses, ComplianceApiCompleteProductActionData, ComplianceApiCompleteProductActionErrors, ComplianceApiCompleteProductActionResponses, ComplianceApiGetActionItemsData, ComplianceApiGetActionItemsResponses, ComplianceApiGetPogCategoryRateData, ComplianceApiGetPogCategoryRateResponses, ComplianceApiGetProductActionsPostResetPhotoStateData, ComplianceApiGetProductActionsPostResetPhotoStateErrors, ComplianceApiGetProductActionsPostResetPhotoStateResponses, ComplianceApiListPogCategoryRatesData, ComplianceApiListPogCategoryRatesResponses, ComplianceApiListPogStoreRatesData, ComplianceApiListPogStoreRatesResponses, ComplianceApiListProductActionsData, ComplianceApiListProductActionsErrors, ComplianceApiListProductActionsResponses, ComplianceApiUpdateProductActionData, ComplianceApiUpdateProductActionErrors, ComplianceApiUpdateProductActionResponses, CoreHealthcheckApiHealthCheckData, CoreHealthcheckApiHealthCheckResponses, EmployeesApiCreateEmployeeData, EmployeesApiCreateEmployeeErrors, EmployeesApiCreateEmployeeResponses, EmployeesApiDeleteEmployeeData, EmployeesApiDeleteEmployeeErrors, EmployeesApiDeleteEmployeeResponses, EmployeesApiEmployeeStatsData, EmployeesApiEmployeeStatsResponses, EmployeesApiGetEmployeeData, EmployeesApiGetEmployeeResponses, EmployeesApiListEmployeeRolesData, EmployeesApiListEmployeeRolesResponses, EmployeesApiListEmployeesData, EmployeesApiListEmployeesResponses, EmployeesApiListEmploymentTypesData, EmployeesApiListEmploymentTypesResponses, EmployeesApiUpdateEmployeeData, EmployeesApiUpdateEmployeeErrors, EmployeesApiUpdateEmployeeResponses, IngestionApiConnectionsConnectionStatsData, IngestionApiConnectionsConnectionStatsResponses, IngestionApiConnectionsCreateConnectionData, IngestionApiConnectionsCreateConnectionErrors, IngestionApiConnectionsCreateConnectionResponses, IngestionApiConnectionsDeleteConnectionData, IngestionApiConnectionsDeleteConnectionResponses, IngestionApiConnectionsGetConnectionData, IngestionApiConnectionsGetConnectionResponses, IngestionApiConnectionsListConnectionsData, IngestionApiConnectionsListConnectionsResponses, IngestionApiConnectionsSyncConnectionData, IngestionApiConnectionsSyncConnectionErrors, IngestionApiConnectionsSyncConnectionResponses, IngestionApiConnectionsTestConnectionData, IngestionApiConnectionsTestConnectionErrors, IngestionApiConnectionsTestConnectionResponses, IngestionApiConnectionsUpdateConnectionData, IngestionApiConnectionsUpdateConnectionErrors, IngestionApiConnectionsUpdateConnectionResponses, IngestionApiImportsApproveImportData, IngestionApiImportsApproveImportErrors, IngestionApiImportsApproveImportResponses, IngestionApiImportsCreateImportData, IngestionApiImportsCreateImportResponses, IngestionApiImportsDownloadImportErrorsCsvData, IngestionApiImportsDownloadImportErrorsCsvResponses, IngestionApiImportsGetImportData, IngestionApiImportsGetImportResponses, IngestionApiImportsImportEventsStreamData, IngestionApiImportsImportEventsStreamResponses, IngestionApiImportsImportsEventsStreamData, IngestionApiImportsImportsEventsStreamResponses, IngestionApiImportsListImportErrorsData, IngestionApiImportsListImportErrorsResponses, IngestionApiImportsListImportsData, IngestionApiImportsListImportsResponses, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentErrors, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentResponses, MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsData, MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsResponses, MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentData, MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentResponses, MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData, MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponses, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentErrors, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentResponses, MappingsApiStoreCategoriesCreateStoreCategoryData, MappingsApiStoreCategoriesCreateStoreCategoryErrors, MappingsApiStoreCategoriesCreateStoreCategoryResponses, MappingsApiStoreCategoriesDeleteStoreCategoryData, MappingsApiStoreCategoriesDeleteStoreCategoryResponses, MappingsApiStoreCategoriesGetStoreCategoryData, MappingsApiStoreCategoriesGetStoreCategoryResponses, MappingsApiStoreCategoriesListStoreCategoriesData, MappingsApiStoreCategoriesListStoreCategoriesResponses, MappingsApiStoreCategoriesStoreCategoryStatsData, MappingsApiStoreCategoriesStoreCategoryStatsResponses, MappingsApiStoreCategoriesUpdateStoreCategoryData, MappingsApiStoreCategoriesUpdateStoreCategoryErrors, MappingsApiStoreCategoriesUpdateStoreCategoryResponses, MappingsApiStorePlanogramsCreateStorePlanogramData, MappingsApiStorePlanogramsCreateStorePlanogramErrors, MappingsApiStorePlanogramsCreateStorePlanogramResponses, MappingsApiStorePlanogramsDeleteStorePlanogramData, MappingsApiStorePlanogramsDeleteStorePlanogramErrors, MappingsApiStorePlanogramsDeleteStorePlanogramResponses, MappingsApiStorePlanogramsGetStorePlanogramData, MappingsApiStorePlanogramsGetStorePlanogramResponses, MappingsApiStorePlanogramsListStorePlanogramsData, MappingsApiStorePlanogramsListStorePlanogramsResponses, MappingsApiStorePlanogramsStorePlanogramStatsData, MappingsApiStorePlanogramsStorePlanogramStatsResponses, MappingsApiStorePlanogramsUpdateStorePlanogramData, MappingsApiStorePlanogramsUpdateStorePlanogramErrors, MappingsApiStorePlanogramsUpdateStorePlanogramResponses, MappingsApiStoreProductsCreateStoreProductData, MappingsApiStoreProductsCreateStoreProductErrors, MappingsApiStoreProductsCreateStoreProductResponses, MappingsApiStoreProductsDeleteStoreProductData, MappingsApiStoreProductsDeleteStoreProductResponses, MappingsApiStoreProductsGetStoreProductData, MappingsApiStoreProductsGetStoreProductResponses, MappingsApiStoreProductsListStoreProductsData, MappingsApiStoreProductsListStoreProductsResponses, MappingsApiStoreProductsStoreProductStatsData, MappingsApiStoreProductsStoreProductStatsResponses, MappingsApiStoreProductsUpdateStoreProductData, MappingsApiStoreProductsUpdateStoreProductErrors, MappingsApiStoreProductsUpdateStoreProductResponses, MappingsApiWorkingGroupsCreateWorkingGroupData, MappingsApiWorkingGroupsCreateWorkingGroupErrors, MappingsApiWorkingGroupsCreateWorkingGroupResponses, MappingsApiWorkingGroupsGetWorkingGroupData, MappingsApiWorkingGroupsGetWorkingGroupResponses, MappingsApiWorkingGroupsListWorkingGroupsData, MappingsApiWorkingGroupsListWorkingGroupsResponses, MappingsApiWorkingGroupsUpdateWorkingGroupData, MappingsApiWorkingGroupsUpdateWorkingGroupErrors, MappingsApiWorkingGroupsUpdateWorkingGroupResponses, MappingsApiWorkingGroupsWorkingGroupStatsData, MappingsApiWorkingGroupsWorkingGroupStatsResponses, MobileApiCompleteWorkItemTaskData, MobileApiCompleteWorkItemTaskResponses, MobileApiGetCompletionSummaryData, MobileApiGetCompletionSummaryErrors, MobileApiGetCompletionSummaryResponses, MobileApiListWorkItemBaysData, MobileApiListWorkItemBaysErrors, MobileApiListWorkItemBaysResponses, MobileApiStartWorkItemTaskData, MobileApiStartWorkItemTaskResponses, MobileApiStartWorkOrderNiciTaskData, MobileApiStartWorkOrderNiciTaskErrors, MobileApiStartWorkOrderNiciTaskResponses, MobileApiStartWorkOrderVisitData, MobileApiStartWorkOrderVisitErrors, MobileApiStartWorkOrderVisitResponses, MobileApiStopWorkOrderNiciTaskData, MobileApiStopWorkOrderNiciTaskErrors, MobileApiStopWorkOrderNiciTaskResponses, MobileApiSubmitWorkOrderNiciScanData, MobileApiSubmitWorkOrderNiciScanErrors, MobileApiSubmitWorkOrderNiciScanResponses, MobileApiValidateWorkOrderLocationData, MobileApiValidateWorkOrderLocationErrors, MobileApiValidateWorkOrderLocationResponses, PlanningApiNiciCreateNiciData, PlanningApiNiciCreateNiciErrors, PlanningApiNiciCreateNiciResponses, PlanningApiNiciDeleteNiciData, PlanningApiNiciDeleteNiciResponses, PlanningApiNiciGetNiciData, PlanningApiNiciGetNiciResponses, PlanningApiNiciListNiciData, PlanningApiNiciListNiciErrors, PlanningApiNiciListNiciResponses, PlanningApiNiciNiciStatsData, PlanningApiNiciNiciStatsResponses, PlanningApiNiciUpdateNiciData, PlanningApiNiciUpdateNiciErrors, PlanningApiNiciUpdateNiciResponses, PlanningApiResetCalendarCreateResetCycleData, PlanningApiResetCalendarCreateResetCycleErrors, PlanningApiResetCalendarCreateResetCycleResponses, PlanningApiResetCalendarDeleteResetCycleData, PlanningApiResetCalendarDeleteResetCycleResponses, PlanningApiResetCalendarGetResetCycleData, PlanningApiResetCalendarGetResetCycleResponses, PlanningApiResetCalendarListResetCyclesData, PlanningApiResetCalendarListResetCyclesResponses, PlanningApiResetCalendarResetCycleStatsData, PlanningApiResetCalendarResetCycleStatsResponses, PlanningApiResetCalendarUpdateResetCycleData, PlanningApiResetCalendarUpdateResetCycleErrors, PlanningApiResetCalendarUpdateResetCycleResponses, PlanogramsApiPlanogramsCreatePlanogramData, PlanogramsApiPlanogramsCreatePlanogramErrors, PlanogramsApiPlanogramsCreatePlanogramResponses, PlanogramsApiPlanogramsDeletePlanogramData, PlanogramsApiPlanogramsDeletePlanogramErrors, PlanogramsApiPlanogramsDeletePlanogramResponses, PlanogramsApiPlanogramsGetPlanogramData, PlanogramsApiPlanogramsGetPlanogramDetailsData, PlanogramsApiPlanogramsGetPlanogramDetailsResponses, PlanogramsApiPlanogramsGetPlanogramResponses, PlanogramsApiPlanogramsListPlanogramsData, PlanogramsApiPlanogramsListPlanogramsResponses, PlanogramsApiPlanogramsPlanogramStatsData, PlanogramsApiPlanogramsPlanogramStatsResponses, PlanogramsApiPlanogramsUpdatePlanogramData, PlanogramsApiPlanogramsUpdatePlanogramErrors, PlanogramsApiPlanogramsUpdatePlanogramResponses, PlanogramsApiPositionsListPlanogramPositionsData, PlanogramsApiPositionsListPlanogramPositionsResponses, PlanogramsApiVersionsGetVersionData, PlanogramsApiVersionsGetVersionResponses, PlanogramsApiVersionsListVersionsData, PlanogramsApiVersionsListVersionsResponses, PlanogramsApiVersionsPublishData, PlanogramsApiVersionsPublishErrors, PlanogramsApiVersionsPublishResponses, PlanogramsApiVersionsStoreReachData, PlanogramsApiVersionsStoreReachResponses, PlanogramsApiVisualizationGetVisualizationData, PlanogramsApiVisualizationGetVisualizationErrors, PlanogramsApiVisualizationGetVisualizationResponses, ProductsProductsApiCreateProductData, ProductsProductsApiCreateProductErrors, ProductsProductsApiCreateProductResponses, ProductsProductsApiDeleteProductData, ProductsProductsApiDeleteProductImageData, ProductsProductsApiDeleteProductImageResponses, ProductsProductsApiDeleteProductResponses, ProductsProductsApiGetProductData, ProductsProductsApiGetProductResponses, ProductsProductsApiListBrandsData, ProductsProductsApiListBrandsResponses, ProductsProductsApiListProductsData, ProductsProductsApiListProductsResponses, ProductsProductsApiProductStatsData, ProductsProductsApiProductStatsResponses, ProductsProductsApiSetPrimaryProductImageData, ProductsProductsApiSetPrimaryProductImageErrors, ProductsProductsApiSetPrimaryProductImageResponses, ProductsProductsApiUpdateProductData, ProductsProductsApiUpdateProductErrors, ProductsProductsApiUpdateProductResponses, ProductsProductsApiUploadProductImageData, ProductsProductsApiUploadProductImageErrors, ProductsProductsApiUploadProductImageResponses, ProjectsApiEditEditAnalyzeData, ProjectsApiEditEditAnalyzeErrors, ProjectsApiEditEditAnalyzeResponses, ProjectsApiEditEditAssignTeamsData, ProjectsApiEditEditAssignTeamsErrors, ProjectsApiEditEditAssignTeamsResponses, ProjectsApiEditEditCancelData, ProjectsApiEditEditCancelErrors, ProjectsApiEditEditCancelResponses, ProjectsApiEditEditCommitData, ProjectsApiEditEditCommitErrors, ProjectsApiEditEditCommitResponses, ProjectsApiEditEditCostEstimateData, ProjectsApiEditEditCostEstimateErrors, ProjectsApiEditEditCostEstimateResponses, ProjectsApiEditEditInitData, ProjectsApiEditEditInitErrors, ProjectsApiEditEditInitResponses, ProjectsApiEditEditResumeData, ProjectsApiEditEditResumeErrors, ProjectsApiEditEditResumeResponses, ProjectsApiEditEditSaveDraftData, ProjectsApiEditEditSaveDraftErrors, ProjectsApiEditEditSaveDraftResponses, ProjectsApiEditEditScheduleData, ProjectsApiEditEditScheduleErrors, ProjectsApiEditEditScheduleResponses, ProjectsApiFieldworkGetVisitAssignmentData, ProjectsApiFieldworkGetVisitAssignmentErrors, ProjectsApiFieldworkGetVisitAssignmentResponses, ProjectsApiFieldworkListAssignedStoresData, ProjectsApiFieldworkListAssignedStoresErrors, ProjectsApiFieldworkListAssignedStoresResponses, ProjectsApiFieldworkListVisitAssignmentsData, ProjectsApiFieldworkListVisitAssignmentsErrors, ProjectsApiFieldworkListVisitAssignmentsResponses, ProjectsApiFieldworkListWorkItemsData, ProjectsApiFieldworkListWorkItemsErrors, ProjectsApiFieldworkListWorkItemsResponses, ProjectsApiFieldworkUpdateVisitAssignmentData, ProjectsApiFieldworkUpdateVisitAssignmentErrors, ProjectsApiFieldworkUpdateVisitAssignmentResponses, ProjectsApiFieldworkUpdateVisitData, ProjectsApiFieldworkUpdateVisitErrors, ProjectsApiFieldworkUpdateVisitResponses, ProjectsApiMissionControlDashboardSummaryData, ProjectsApiMissionControlDashboardSummaryResponses, ProjectsApiMissionControlListAlertsData, ProjectsApiMissionControlListAlertsResponses, ProjectsApiMissionControlListEscalationsData, ProjectsApiMissionControlListEscalationsResponses, ProjectsApiMissionControlListWorkOrdersData, ProjectsApiMissionControlListWorkOrdersErrors, ProjectsApiMissionControlListWorkOrdersResponses, ProjectsApiMissionControlResolveEscalationData, ProjectsApiMissionControlResolveEscalationErrors, ProjectsApiMissionControlResolveEscalationResponses, ProjectsApiNiciResolutionsCreateNiciResolutionData, ProjectsApiNiciResolutionsCreateNiciResolutionErrors, ProjectsApiNiciResolutionsCreateNiciResolutionResponses, ProjectsApiNiciScansListNiciScansData, ProjectsApiNiciScansListNiciScansErrors, ProjectsApiNiciScansListNiciScansResponses, ProjectsApiNiciTrackingListNiciItemsData, ProjectsApiNiciTrackingListNiciItemsErrors, ProjectsApiNiciTrackingListNiciItemsResponses, ProjectsApiNiciTrackingListNiciStoresData, ProjectsApiNiciTrackingListNiciStoresErrors, ProjectsApiNiciTrackingListNiciStoresResponses, ProjectsApiNiciTrackingNiciItemRolloutData, ProjectsApiNiciTrackingNiciItemRolloutErrors, ProjectsApiNiciTrackingNiciItemRolloutResponses, ProjectsApiNiciTrackingNiciProjectSummaryData, ProjectsApiNiciTrackingNiciProjectSummaryResponses, ProjectsApiProjectsApplyBackroomNewItemCollectionActionData, ProjectsApiProjectsApplyBackroomNewItemCollectionActionErrors, ProjectsApiProjectsApplyBackroomNewItemCollectionActionResponses, ProjectsApiProjectsCreateExceptionEventData, ProjectsApiProjectsCreateExceptionEventErrors, ProjectsApiProjectsCreateExceptionEventResponses, ProjectsApiProjectsCreateFieldPhotoData, ProjectsApiProjectsCreateFieldPhotoErrors, ProjectsApiProjectsCreateFieldPhotoResponses, ProjectsApiProjectsCreateProjectData, ProjectsApiProjectsCreateProjectErrors, ProjectsApiProjectsCreateProjectResponses, ProjectsApiProjectsDeleteProjectData, ProjectsApiProjectsDeleteProjectResponses, ProjectsApiProjectsGetBackroomNewItemRequirementsData, ProjectsApiProjectsGetBackroomNewItemRequirementsResponses, ProjectsApiProjectsGetProjectData, ProjectsApiProjectsGetProjectResponses, ProjectsApiProjectsListCyclesData, ProjectsApiProjectsListCyclesResponses, ProjectsApiProjectsListExceptionEventTypesData, ProjectsApiProjectsListExceptionEventTypesResponses, ProjectsApiProjectsListFieldPhotosData, ProjectsApiProjectsListFieldPhotosResponses, ProjectsApiProjectsListProjectsData, ProjectsApiProjectsListProjectsResponses, ProjectsApiProjectsListWorkOrderWorkItemsData, ProjectsApiProjectsListWorkOrderWorkItemsErrors, ProjectsApiProjectsListWorkOrderWorkItemsResponses, ProjectsApiProjectsTransitionProjectData, ProjectsApiProjectsTransitionProjectErrors, ProjectsApiProjectsTransitionProjectResponses, ProjectsApiProjectsUpdateProjectData, ProjectsApiProjectsUpdateProjectErrors, ProjectsApiProjectsUpdateProjectResponses, ProjectsApiProjectsUpdateWorkItemData, ProjectsApiProjectsUpdateWorkItemErrors, ProjectsApiProjectsUpdateWorkItemResponses, ProjectsApiTimeEntriesListTimeEntriesData, ProjectsApiTimeEntriesListTimeEntriesErrors, ProjectsApiTimeEntriesListTimeEntriesResponses, ProjectsApiTimesheetsGetBreakFormData, ProjectsApiTimesheetsGetBreakFormErrors, ProjectsApiTimesheetsGetBreakFormResponses, ProjectsApiTimesheetsGetTimesheetData, ProjectsApiTimesheetsGetTimesheetErrors, ProjectsApiTimesheetsGetTimesheetResponses, ProjectsApiTimesheetsListTimesheetsData, ProjectsApiTimesheetsListTimesheetsErrors, ProjectsApiTimesheetsListTimesheetsResponses, ProjectsApiTimesheetsUpdateTimesheetData, ProjectsApiTimesheetsUpdateTimesheetErrors, ProjectsApiTimesheetsUpdateTimesheetResponses, ProjectsApiWizardWizardAnalyzeData, ProjectsApiWizardWizardAnalyzeErrors, ProjectsApiWizardWizardAnalyzeResponses, ProjectsApiWizardWizardAnalyzeV2Data, ProjectsApiWizardWizardAnalyzeV2Errors, ProjectsApiWizardWizardAnalyzeV2Responses, ProjectsApiWizardWizardApproveData, ProjectsApiWizardWizardApproveErrors, ProjectsApiWizardWizardApproveResponses, ProjectsApiWizardWizardAssignTeamsV2Data, ProjectsApiWizardWizardAssignTeamsV2Errors, ProjectsApiWizardWizardAssignTeamsV2Responses, ProjectsApiWizardWizardCostEstimateData, ProjectsApiWizardWizardCostEstimateErrors, ProjectsApiWizardWizardCostEstimateResponses, ProjectsApiWizardWizardCreateData, ProjectsApiWizardWizardCreateErrors, ProjectsApiWizardWizardCreateResponses, ProjectsApiWizardWizardInitData, ProjectsApiWizardWizardInitErrors, ProjectsApiWizardWizardInitResponses, ProjectsApiWizardWizardOptionsData, ProjectsApiWizardWizardOptionsResponses, ProjectsApiWizardWizardParseDescriptionData, ProjectsApiWizardWizardParseDescriptionErrors, ProjectsApiWizardWizardParseDescriptionResponses, ProjectsApiWizardWizardParseVoiceData, ProjectsApiWizardWizardParseVoiceErrors, ProjectsApiWizardWizardParseVoiceResponses, ProjectsApiWizardWizardProjectTypesData, ProjectsApiWizardWizardProjectTypesResponses, ProjectsApiWizardWizardRefreshData, ProjectsApiWizardWizardRefreshErrors, ProjectsApiWizardWizardRefreshResponses, ProjectsApiWizardWizardResumeData, ProjectsApiWizardWizardResumeErrors, ProjectsApiWizardWizardResumeResponses, ProjectsApiWizardWizardSaveDraftData, ProjectsApiWizardWizardSaveDraftErrors, ProjectsApiWizardWizardSaveDraftResponses, ProjectsApiWizardWizardScheduleApplyData, ProjectsApiWizardWizardScheduleApplyErrors, ProjectsApiWizardWizardScheduleApplyResponses, ProjectsApiWizardWizardScheduleV2Data, ProjectsApiWizardWizardScheduleV2Errors, ProjectsApiWizardWizardScheduleV2Responses, ProjectsApiWizardWizardTranscribeData, ProjectsApiWizardWizardTranscribeErrors, ProjectsApiWizardWizardTranscribeResponses, RulesApiCreateRuleData, RulesApiCreateRuleErrors, RulesApiCreateRuleResponses, RulesApiDeleteRuleData, RulesApiDeleteRuleResponses, RulesApiGetRuleData, RulesApiGetRuleResponses, RulesApiListRulesData, RulesApiListRulesResponses, RulesApiRuleStatsData, RulesApiRuleStatsResponses, RulesApiUpdateRuleData, RulesApiUpdateRuleErrors, RulesApiUpdateRuleResponses, StorageApiLocalFsUploadData, StorageApiLocalFsUploadErrors, StorageApiLocalFsUploadResponses, StorageApiRequestUploadData, StorageApiRequestUploadResponses, StoresApiCreateStoreData, StoresApiCreateStoreErrors, StoresApiCreateStoreResponses, StoresApiDeleteStoreData, StoresApiDeleteStoreResponses, StoresApiGetStoreData, StoresApiGetStoreResponses, StoresApiListBannersData, StoresApiListBannersResponses, StoresApiListRegionsData, StoresApiListRegionsResponses, StoresApiListSegmentsData, StoresApiListSegmentsResponses, StoresApiListStatesData, StoresApiListStatesResponses, StoresApiListStoreFormatsData, StoresApiListStoreFormatsResponses, StoresApiListStoreGroupsData, StoresApiListStoreGroupsResponses, StoresApiListStoresData, StoresApiListStoresResponses, StoresApiListStoreTypesData, StoresApiListStoreTypesResponses, StoresApiStoreStatsData, StoresApiStoreStatsResponses, StoresApiUpdateStoreData, StoresApiUpdateStoreErrors, StoresApiUpdateStoreResponses, SupervisorApiCreateChatData, SupervisorApiCreateChatErrors, SupervisorApiCreateChatResponses, SupervisorApiListChatsData, SupervisorApiListChatsResponses, SupervisorApiListMessagesData, SupervisorApiListMessagesErrors, SupervisorApiListMessagesResponses, SupervisorApiSendMessageData, SupervisorApiSendMessageErrors, SupervisorApiSendMessageResponses, SuppliersApiListSuppliersData, SuppliersApiListSuppliersResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Health Check
 *
 * Comprehensive healthcheck that verifies backing services.
 *
 * Checks performed:
 * 1. Required environment variables are present.
 * 2. PostgreSQL connection is working.
 * 3. Redis connection is working.
 *
 * Returns:
 * ``JsonResponse`` with HTTP 200 if all checks pass, or
 * HTTP 503 if any check fails. The body contains per-check
 * status details under ``checks``.
 */
export const coreHealthcheckApiHealthCheck = <ThrowOnError extends boolean = false>(options?: Options<CoreHealthcheckApiHealthCheckData, ThrowOnError>) => (options?.client ?? client).get<CoreHealthcheckApiHealthCheckResponses, unknown, ThrowOnError>({ url: '/api/v1/healthcheck/', ...options });

/**
 * Get Authentication Methods
 *
 * Return the available authentication methods for a client surface.
 */
export const accountsApiDiscoveryGetAuthenticationMethods = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiDiscoveryGetAuthenticationMethodsData, ThrowOnError>) => (options?.client ?? client).get<AccountsApiDiscoveryGetAuthenticationMethodsResponses, AccountsApiDiscoveryGetAuthenticationMethodsErrors, ThrowOnError>({ url: '/api/v1/auth/methods/', ...options });

/**
 * Google Login
 *
 * Exchange a Google token for a JWT access token.
 */
export const accountsApiLegacyGoogleLogin = <ThrowOnError extends boolean = false>(options: Options<AccountsApiLegacyGoogleLoginData, ThrowOnError>) => (options.client ?? client).post<AccountsApiLegacyGoogleLoginResponses, AccountsApiLegacyGoogleLoginErrors, ThrowOnError>({
    url: '/api/v1/auth/google/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout
 *
 * Clear the auth cookie and Django session.
 *
 * Note: the JWT itself is not revoked — it remains valid
 * until its ``exp`` timestamp. This is inherent to
 * stateless JWTs; logout == "clear the browser's copy".
 * If stricter revocation becomes a requirement, add a
 * ``jti`` denylist in Redis and check it in
 * ``JWTAuthMiddleware``.
 *
 * Requires CSRF (see ``CookieCsrfMiddleware``): the
 * endpoint is intentionally *not* listed in
 * ``PUBLIC_PREFIXES``, so a valid auth cookie +
 * ``X-CSRFToken`` header are both required.
 */
export const accountsApiLegacyLogout = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiLegacyLogoutData, ThrowOnError>) => (options?.client ?? client).post<AccountsApiLegacyLogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/logout/', ...options });

/**
 * Get Current User
 *
 * Return the current authenticated user's profile.
 *
 * Pure read — does *not* re-issue the JWT or refresh the
 * cookie. If a sliding session is needed in the future,
 * add a dedicated ``/refresh/`` endpoint rather than
 * silently extending the session on every poll.
 */
export const accountsApiProfileGetCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiProfileGetCurrentUserData, ThrowOnError>) => (options?.client ?? client).get<AccountsApiProfileGetCurrentUserResponses, AccountsApiProfileGetCurrentUserErrors, ThrowOnError>({ url: '/api/v1/auth/me/', ...options });

/**
 * Request
 *
 * Request an opaque OTP challenge without exposing account eligibility.
 */
export const accountsApiOtpRequest = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiOtpRequestData, ThrowOnError>) => (options?.client ?? client).post<AccountsApiOtpRequestResponses, AccountsApiOtpRequestErrors, ThrowOnError>({ url: '/api/v1/auth/otp/request/', ...options });

/**
 * Verify
 *
 * Verify a challenge and establish an application session on success.
 */
export const accountsApiOtpVerify = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiOtpVerifyData, ThrowOnError>) => (options?.client ?? client).post<AccountsApiOtpVerifyResponses, AccountsApiOtpVerifyErrors, ThrowOnError>({ url: '/api/v1/auth/otp/verify/', ...options });

/**
 * Refresh
 *
 * Rotate a cookie-held application refresh credential.
 */
export const accountsApiSessionsRefresh = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiSessionsRefreshData, ThrowOnError>) => (options?.client ?? client).post<AccountsApiSessionsRefreshResponses, AccountsApiSessionsRefreshErrors, ThrowOnError>({ url: '/api/v1/auth/session/refresh/', ...options });

/**
 * Session Logout
 *
 * Revoke a cookie-held application session and clear browser credentials.
 *
 * The endpoint never clears browser state before a valid request.
 */
export const accountsApiSessionsSessionLogout = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiSessionsSessionLogoutData, ThrowOnError>) => (options?.client ?? client).post<AccountsApiSessionsSessionLogoutResponses, AccountsApiSessionsSessionLogoutErrors, ThrowOnError>({ url: '/api/v1/auth/session/logout/', ...options });

/**
 * Exchange
 *
 * Exchange one PKCE-bound SSO login code for application credentials.
 */
export const accountsApiSsoExchange = <ThrowOnError extends boolean = false>(options?: Options<AccountsApiSsoExchangeData, ThrowOnError>) => (options?.client ?? client).post<AccountsApiSsoExchangeResponses, AccountsApiSsoExchangeErrors, ThrowOnError>({ url: '/api/v1/auth/sso/exchange/', ...options });

/**
 * List Cycles
 */
export const projectsApiProjectsListCycles = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiProjectsListCyclesData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiProjectsListCyclesResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/cycles/', ...options });

/**
 * List Projects
 */
export const projectsApiProjectsListProjects = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiProjectsListProjectsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiProjectsListProjectsResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/', ...options });

/**
 * Create Project
 */
export const projectsApiProjectsCreateProject = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsCreateProjectData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiProjectsCreateProjectResponses, ProjectsApiProjectsCreateProjectErrors, ThrowOnError>({
    url: '/api/v1/projects/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Work Order Work Items
 */
export const projectsApiProjectsListWorkOrderWorkItems = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsListWorkOrderWorkItemsData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiProjectsListWorkOrderWorkItemsResponses, ProjectsApiProjectsListWorkOrderWorkItemsErrors, ThrowOnError>({ url: '/api/v1/projects/work-orders/{work_order_id}/work-items/', ...options });

/**
 * Update Work Item
 */
export const projectsApiProjectsUpdateWorkItem = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsUpdateWorkItemData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiProjectsUpdateWorkItemResponses, ProjectsApiProjectsUpdateWorkItemErrors, ThrowOnError>({
    url: '/api/v1/projects/work-items/{work_item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Backroom New Item Requirements
 */
export const projectsApiProjectsGetBackroomNewItemRequirements = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsGetBackroomNewItemRequirementsData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiProjectsGetBackroomNewItemRequirementsResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/work-items/{work_item_id}/backroom-new-item-requirements/', ...options });

/**
 * Apply Backroom New Item Collection Action
 */
export const projectsApiProjectsApplyBackroomNewItemCollectionAction = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsApplyBackroomNewItemCollectionActionData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiProjectsApplyBackroomNewItemCollectionActionResponses, ProjectsApiProjectsApplyBackroomNewItemCollectionActionErrors, ThrowOnError>({
    url: '/api/v1/projects/work-items/{work_item_id}/backroom-new-item-collection/actions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Exception Event
 */
export const projectsApiProjectsCreateExceptionEvent = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsCreateExceptionEventData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiProjectsCreateExceptionEventResponses, ProjectsApiProjectsCreateExceptionEventErrors, ThrowOnError>({
    url: '/api/v1/projects/exceptions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Exception Event Types
 */
export const projectsApiProjectsListExceptionEventTypes = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiProjectsListExceptionEventTypesData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiProjectsListExceptionEventTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/exception-event-types/', ...options });

/**
 * List Field Photos
 */
export const projectsApiProjectsListFieldPhotos = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiProjectsListFieldPhotosData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiProjectsListFieldPhotosResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/field-photos/', ...options });

/**
 * Create Field Photo
 */
export const projectsApiProjectsCreateFieldPhoto = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsCreateFieldPhotoData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiProjectsCreateFieldPhotoResponses, ProjectsApiProjectsCreateFieldPhotoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/projects/field-photos/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Project
 */
export const projectsApiProjectsDeleteProject = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsDeleteProjectData, ThrowOnError>) => (options.client ?? client).delete<ProjectsApiProjectsDeleteProjectResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/{project_id}', ...options });

/**
 * Get Project
 */
export const projectsApiProjectsGetProject = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsGetProjectData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiProjectsGetProjectResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/{project_id}', ...options });

/**
 * Update Project
 */
export const projectsApiProjectsUpdateProject = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsUpdateProjectData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiProjectsUpdateProjectResponses, ProjectsApiProjectsUpdateProjectErrors, ThrowOnError>({
    url: '/api/v1/projects/{project_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Transition Project
 */
export const projectsApiProjectsTransitionProject = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiProjectsTransitionProjectData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiProjectsTransitionProjectResponses, ProjectsApiProjectsTransitionProjectErrors, ThrowOnError>({
    url: '/api/v1/projects/{project_id}/transition',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initialize a new project with scope analysis
 *
 * Create a DRAFT project and return scope analysis summary.
 */
export const projectsApiWizardWizardInit = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardInitData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardInitResponses, ProjectsApiWizardWizardInitErrors, ThrowOnError>({
    url: '/api/v1/projects/wizard/init',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Persist wizard draft: project basics and overrides
 *
 * Unified user-initiated draft editor.
 *
 * Full-replacement semantics for both Project basics and wizard
 * overrides. The client sends the complete draft snapshot; the
 * server replaces both blocks atomically. Uses ``If-Match`` for
 * optimistic concurrency, checked inside a row lock to prevent
 * lost updates between concurrent sessions.
 */
export const projectsApiWizardWizardSaveDraft = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardSaveDraftData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiWizardWizardSaveDraftResponses, ProjectsApiWizardWizardSaveDraftErrors, ThrowOnError>({
    url: '/api/v1/projects/wizard/{project_id}/save-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resume a draft project wizard
 *
 * Return the current draft state for the wizard UI.
 *
 * Reads are tolerant: if a stored slot fails schema validation
 * (schema drift across deployments), it is dropped from the
 * returned view and the derived wizard_step reflects the walk
 * stopping at the first invalid slot. Stale slots are returned
 * as-is with ``stale.<slot> = True``.
 */
export const projectsApiWizardWizardResume = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardResumeData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiWizardWizardResumeResponses, ProjectsApiWizardWizardResumeErrors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/resume', ...options });

/**
 * Wizard Options
 */
export const projectsApiWizardWizardOptions = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiWizardWizardOptionsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiWizardWizardOptionsResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/wizard/options', ...options });

/**
 * Wizard Project Types
 *
 * Return only the task-type choices and transcription flag.
 *
 * A lightweight companion to ``/options`` that skips the categories
 * and cycles queries so the create-project form can render its Task
 * Type cards without waiting on data it does not need.
 */
export const projectsApiWizardWizardProjectTypes = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiWizardWizardProjectTypesData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiWizardWizardProjectTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/projects/wizard/project-types', ...options });

/**
 * Wizard Parse Description
 */
export const projectsApiWizardWizardParseDescription = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardParseDescriptionData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardParseDescriptionResponses, ProjectsApiWizardWizardParseDescriptionErrors, ThrowOnError>({
    url: '/api/v1/projects/wizard/parse-description',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Wizard Transcribe
 *
 * Transcribe an audio clip via OpenAI Whisper.
 */
export const projectsApiWizardWizardTranscribe = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardTranscribeData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardTranscribeResponses, ProjectsApiWizardWizardTranscribeErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/projects/wizard/transcribe',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Wizard Parse Voice
 *
 * Transcribe audio and parse project description in one call.
 */
export const projectsApiWizardWizardParseVoice = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardParseVoiceData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardParseVoiceResponses, ProjectsApiWizardWizardParseVoiceErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/projects/wizard/parse-voice',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Run scope validation and AI analysis for a draft project
 *
 * Validate project scope and persist the analysis result.
 *
 * Loads the DRAFT project, runs ScopeAggregator with user
 * overrides, and writes the scope slot (including backend-only
 * detail keys) directly to ``wizard_state["scope"]``.
 */
export const projectsApiWizardWizardAnalyzeV2 = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardAnalyzeV2Data, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardAnalyzeV2Responses, ProjectsApiWizardWizardAnalyzeV2Errors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/analyze', ...options });

/**
 * Wizard Analyze
 */
export const projectsApiWizardWizardAnalyze = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardAnalyzeData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardAnalyzeResponses, ProjectsApiWizardWizardAnalyzeErrors, ThrowOnError>({
    url: '/api/v1/projects/wizard/analyze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate multi-cycle schedule
 *
 * Generate day-level schedule for all project cycles.
 *
 * Apply the selected mode's visit frequency to source work and allowed
 * cycle dates, then persist the result in ``wizard_state['schedule']``.
 */
export const projectsApiWizardWizardScheduleV2 = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardScheduleV2Data, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardScheduleV2Responses, ProjectsApiWizardWizardScheduleV2Errors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/schedule', ...options });

/**
 * Apply schedule-level overrides and regenerate schedule
 *
 * Full-replacement write of schedule-level overrides +
 * atomic schedule regeneration.
 *
 * Preserves scope-level overrides (category_ids, store_ids,
 * notes, assignment_overrides, nici_rollover_exclusions) —
 * those are owned by PATCH /save-draft.
 *
 * Downstream slots (assignments, cost) become stale via
 * schedule_inputs_hash change; the client sees stale flags
 * through GET /resume.
 */
export const projectsApiWizardWizardScheduleApply = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardScheduleApplyData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardScheduleApplyResponses, ProjectsApiWizardWizardScheduleApplyErrors, ThrowOnError>({
    url: '/api/v1/projects/wizard/{project_id}/schedule/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate multi-cycle team assignments
 *
 * Assign employees to stores across all project cycles.
 *
 * Reads the schedule from wizard_state, runs the 3-pass
 * assignment engine, and persists the result in
 * wizard_state['assignments'].
 */
export const projectsApiWizardWizardAssignTeamsV2 = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardAssignTeamsV2Data, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardAssignTeamsV2Responses, ProjectsApiWizardWizardAssignTeamsV2Errors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/assign-teams', ...options });

/**
 * Calculate cost estimate and persist
 *
 * Calculate labor + mileage costs, generate warnings,
 * and persist the result in wizard_state['cost'].
 *
 * Updates Project cost fields for quick reads.
 */
export const projectsApiWizardWizardCostEstimate = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardCostEstimateData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardCostEstimateResponses, ProjectsApiWizardWizardCostEstimateErrors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/cost-estimate', ...options });

/**
 * Rebuild a draft's results from current data
 *
 * Re-run every filled wizard step with current planning data.
 *
 * User overrides are kept. Returns the same body as ``/resume``.
 */
export const projectsApiWizardWizardRefresh = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardRefreshData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardRefreshResponses, ProjectsApiWizardWizardRefreshErrors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/refresh', ...options });

/**
 * Wizard Create
 */
export const projectsApiWizardWizardCreate = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardCreateData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardCreateResponses, ProjectsApiWizardWizardCreateErrors, ThrowOnError>({
    url: '/api/v1/projects/wizard/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve and publish a draft project
 *
 * Finalise the wizard: build execution structure, then publish.
 *
 * Calls ``build_project_structure`` (T-016) to create ProjectCycles,
 * WorkOrders and typed WorkItems. Then records approval
 * metadata and transitions the project from DRAFT to PUBLISHED.
 *
 * All mutations happen inside a single atomic block so a failure
 * at any point rolls back everything.
 */
export const projectsApiWizardWizardApprove = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiWizardWizardApproveData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiWizardWizardApproveResponses, ProjectsApiWizardWizardApproveErrors, ThrowOnError>({ url: '/api/v1/projects/wizard/{project_id}/approve', ...options });

/**
 * Begin a project-level edit session
 *
 * Create or reset an edit session for a PUBLISHED project.
 *
 * Snapshots the current params into ``edit_state.base`` / ``new_params``
 * and computes the future-window anchor. Idempotent-guarded: returns
 * 409 if a session is already active, unless ``force=true``.
 */
export const projectsApiEditEditInit = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditInitData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditInitResponses, ProjectsApiEditEditInitErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/init', ...options });

/**
 * Save proposed edit parameters
 *
 * Full-replacement write of proposed edit parameters.
 *
 * Replaces ``new_params`` in the active edit session and
 * invalidates any previously-computed downstream slots
 * (scope / schedule / assignments / cost).
 */
export const projectsApiEditEditSaveDraft = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditSaveDraftData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiEditEditSaveDraftResponses, ProjectsApiEditEditSaveDraftErrors, ThrowOnError>({
    url: '/api/v1/projects/{project_id}/edit/save-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read the active edit session
 *
 * Return the current edit session state for the UI.
 *
 * Returns ``active: false`` when no session is in progress;
 * returns the full ``edit_state`` dict when one is active.
 */
export const projectsApiEditEditResume = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditResumeData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiEditEditResumeResponses, ProjectsApiEditEditResumeErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/resume', ...options });

/**
 * Discard the active edit session
 *
 * Clear ``edit_state`` for the project.
 *
 * Idempotent: safe to call even when no session is active.
 *
 * Unlike the mutating compute endpoints, cancel deliberately does
 * NOT require the project to be PUBLISHED — it is a cleanup action
 * that must be able to discard a stale session even if the project
 * has since moved to another status (e.g. LOCKED).
 */
export const projectsApiEditEditCancel = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditCancelData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditCancelResponses, ProjectsApiEditEditCancelErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/cancel', ...options });

/**
 * Recompute future-window scope and preview the delta
 *
 * Recompute scope over the future window and persist the scope slot.
 *
 * Mirrors ``wizard_analyze_v2`` but operates on ``edit_state`` and the
 * future-only window (anchored so cycle numbers continue past preserved
 * cycles). Also runs the reconciler in dry-run mode to produce a delta
 * preview (cycles created/deleted/modified, WO/WI deltas, warnings).
 * Blockers (e.g. "no stores in scope") set ``can_commit=False``.
 */
export const projectsApiEditEditAnalyze = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditAnalyzeData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditAnalyzeResponses, ProjectsApiEditEditAnalyzeErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/analyze', ...options });

/**
 * Recompute future-window schedule
 *
 * Generate a day-level schedule over the edit future window.
 *
 * Mirrors ``wizard_schedule_v2`` but reads/writes ``edit_state``
 * and gates on the edit scope slot being present.
 */
export const projectsApiEditEditSchedule = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditScheduleData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditScheduleResponses, ProjectsApiEditEditScheduleErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/schedule', ...options });

/**
 * Recompute future-window team assignments
 *
 * Assign employees to stores across the edit future window.
 *
 * Mirrors ``wizard_assign_teams_v2`` but reads/writes ``edit_state``
 * and gates on the edit schedule slot being present.
 */
export const projectsApiEditEditAssignTeams = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditAssignTeamsData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditAssignTeamsResponses, ProjectsApiEditEditAssignTeamsErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/assign-teams', ...options });

/**
 * Recompute future-window cost estimate
 *
 * Calculate labor + mileage costs for the edit future window.
 *
 * Mirrors ``wizard_cost_estimate`` but reads/writes ``edit_state``
 * and gates on the edit assignments slot being present.
 */
export const projectsApiEditEditCostEstimate = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditCostEstimateData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditCostEstimateResponses, ProjectsApiEditEditCostEstimateErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/cost-estimate', ...options });

/**
 * Apply the edit delta to the published project
 *
 * Apply the edit delta to the published project.
 *
 * Guards in order:
 * 1. Must have a scope slot (else 400).
 * 2. If-Match optimistic lock vs the live locked row's updated_at (else 412).
 * 3. Staleness guard: recompute scope hash from current master data;
 * mismatch means data drifted or a cycle activated (else 409).
 * 4. Age guard: the instant /edit/analyze pinned is replayed here, and
 * past ``EDIT_SCOPE_MAX_AGE`` it no longer describes the world
 * (else 409).
 * 5. Blocker guard: scope has blockers / can_proceed is False (else 400).
 *
 * On success: applies the reconciler delta, updates effective_range +
 * cost fields from the edit_state cost slot, clears edit_state, and
 * saves. The project STAYS PUBLISHED (no state-machine transition).
 * On any guard failure, edit_state is left intact.
 */
export const projectsApiEditEditCommit = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiEditEditCommitData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiEditEditCommitResponses, ProjectsApiEditEditCommitErrors, ThrowOnError>({ url: '/api/v1/projects/{project_id}/edit/commit', ...options });

/**
 * List Nici Scans
 *
 * List scans, limiting non-privileged callers to their own records.
 */
export const projectsApiNiciScansListNiciScans = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiNiciScansListNiciScansData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiNiciScansListNiciScansResponses, ProjectsApiNiciScansListNiciScansErrors, ThrowOnError>({ url: '/api/v1/projects/nici-scans/', ...options });

/**
 * List Time Entries
 */
export const projectsApiTimeEntriesListTimeEntries = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiTimeEntriesListTimeEntriesData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiTimeEntriesListTimeEntriesResponses, ProjectsApiTimeEntriesListTimeEntriesErrors, ThrowOnError>({ url: '/api/v1/projects/time-entries/', ...options });

/**
 * Create Nici Resolution
 */
export const projectsApiNiciResolutionsCreateNiciResolution = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiNiciResolutionsCreateNiciResolutionData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiNiciResolutionsCreateNiciResolutionResponses, ProjectsApiNiciResolutionsCreateNiciResolutionErrors, ThrowOnError>({
    url: '/api/v1/projects/work-items/{work_item_id}/nici-resolutions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Category Stats
 *
 * Return aggregate category statistics.
 *
 * Computes the total number of categories and a breakdown
 * by hierarchy level.
 *
 * Returns:
 * A dict with ``total`` count and ``by_level`` mapping
 * of ``{level: count}``.
 */
export const categoriesApiCategoryStats = <ThrowOnError extends boolean = false>(options?: Options<CategoriesApiCategoryStatsData, ThrowOnError>) => (options?.client ?? client).get<CategoriesApiCategoryStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/categories/stats/', ...options });

/**
 * List Categories
 *
 * Return a paginated list of categories.
 *
 * Supports optional filtering by text search (``code``,
 * ``name``), hierarchy ``level``, and ``parent_id``.
 *
 * Args:
 * request: The incoming HTTP request.
 * search: Free-text search across ``code`` and
 * ``name`` fields (case-insensitive contains).
 * level: Filter by exact hierarchy depth.
 * parent_id: Filter by parent category UUID.
 * page: Page number (1-indexed).
 * page_size: Number of results per page.
 *
 * Returns:
 * Paginated response envelope with ``count``, ``next``,
 * ``previous``, and ``results``.
 */
export const categoriesApiListCategories = <ThrowOnError extends boolean = false>(options?: Options<CategoriesApiListCategoriesData, ThrowOnError>) => (options?.client ?? client).get<CategoriesApiListCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v1/categories/', ...options });

/**
 * Create Category
 *
 * Create a new category node.
 *
 * Args:
 * request: The incoming HTTP request.
 * payload: Category data to create.
 *
 * Returns:
 * A tuple of ``(201, created_category)`` on success, or
 * ``(409, error_detail)`` if a uniqueness constraint is
 * violated.
 */
export const categoriesApiCreateCategory = <ThrowOnError extends boolean = false>(options: Options<CategoriesApiCreateCategoryData, ThrowOnError>) => (options.client ?? client).post<CategoriesApiCreateCategoryResponses, CategoriesApiCreateCategoryErrors, ThrowOnError>({
    url: '/api/v1/categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Category
 *
 * Delete a category by its UUID.
 *
 * Cascading deletion will also remove child categories
 * linked via the ``parent`` FK.
 *
 * Args:
 * request: The incoming HTTP request.
 * category_id: UUID of the category to delete.
 *
 * Returns:
 * A tuple of ``(204, None)`` on successful deletion, or
 * ``(409, error_detail)`` if the category is referenced.
 *
 * Raises:
 * Http404: If no category with the given UUID exists.
 */
export const categoriesApiDeleteCategory = <ThrowOnError extends boolean = false>(options: Options<CategoriesApiDeleteCategoryData, ThrowOnError>) => (options.client ?? client).delete<CategoriesApiDeleteCategoryResponses, CategoriesApiDeleteCategoryErrors, ThrowOnError>({ url: '/api/v1/categories/{category_id}', ...options });

/**
 * Get Category
 *
 * Retrieve a single category by its UUID.
 *
 * Args:
 * request: The incoming HTTP request.
 * category_id: UUID of the category to retrieve.
 *
 * Returns:
 * The matching ``Category`` instance.
 *
 * Raises:
 * Http404: If no category with the given UUID exists.
 */
export const categoriesApiGetCategory = <ThrowOnError extends boolean = false>(options: Options<CategoriesApiGetCategoryData, ThrowOnError>) => (options.client ?? client).get<CategoriesApiGetCategoryResponses, unknown, ThrowOnError>({ url: '/api/v1/categories/{category_id}', ...options });

/**
 * Update Category
 *
 * Partially update an existing category.
 *
 * Only fields present in the request body are updated
 * (PATCH semantics via ``exclude_unset``).
 *
 * Args:
 * request: The incoming HTTP request.
 * category_id: UUID of the category to update.
 * payload: Partial category data to apply.
 *
 * Returns:
 * A tuple of ``(200, updated_category)`` on success, or
 * ``(409, error_detail)`` if a uniqueness constraint is
 * violated.
 *
 * Raises:
 * Http404: If no category with the given UUID exists.
 */
export const categoriesApiUpdateCategory = <ThrowOnError extends boolean = false>(options: Options<CategoriesApiUpdateCategoryData, ThrowOnError>) => (options.client ?? client).patch<CategoriesApiUpdateCategoryResponses, CategoriesApiUpdateCategoryErrors, ThrowOnError>({
    url: '/api/v1/categories/{category_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store Stats
 *
 * Return aggregate store statistics, optionally scoped by a filter.
 */
export const storesApiStoreStats = <ThrowOnError extends boolean = false>(options?: Options<StoresApiStoreStatsData, ThrowOnError>) => (options?.client ?? client).get<StoresApiStoreStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/stats/', ...options });

/**
 * List Segments
 *
 * List store segment lookup values.
 *
 * When ``in_use=true``, only segments assigned to at least one
 * store are returned.
 */
export const storesApiListSegments = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListSegmentsData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListSegmentsResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/segments/', ...options });

/**
 * List Store Types
 *
 * List store type lookup values.
 */
export const storesApiListStoreTypes = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListStoreTypesData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListStoreTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/types/', ...options });

/**
 * List Store Formats
 *
 * List store format lookup values.
 */
export const storesApiListStoreFormats = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListStoreFormatsData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListStoreFormatsResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/formats/', ...options });

/**
 * List Regions
 *
 * List regions assigned to at least one store.
 *
 * The "Region" filter in the Store List UI mirrors the table's
 * ``Region`` column, which is sourced from a store's direct
 * ``parent_hierarchy_node``. We therefore return distinct hierarchy
 * nodes that are referenced by at least one ``Store.parent_hierarchy_node``
 * — regardless of which level they live at in the hierarchy tree.
 */
export const storesApiListRegions = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListRegionsData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListRegionsResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/regions/', ...options });

/**
 * List Banners
 *
 * List banners assigned to at least one store.
 */
export const storesApiListBanners = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListBannersData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListBannersResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/banners/', ...options });

/**
 * List Store Groups
 *
 * List store groups for the scope picker.
 */
export const storesApiListStoreGroups = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListStoreGroupsData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListStoreGroupsResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/store-groups/', ...options });

/**
 * List States
 *
 * List distinct state values across all stores.
 */
export const storesApiListStates = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListStatesData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListStatesResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/states/', ...options });

/**
 * List Stores
 *
 * List stores with search, filtering, and pagination.
 */
export const storesApiListStores = <ThrowOnError extends boolean = false>(options?: Options<StoresApiListStoresData, ThrowOnError>) => (options?.client ?? client).get<StoresApiListStoresResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/', ...options });

/**
 * Create Store
 *
 * Create a new store.
 */
export const storesApiCreateStore = <ThrowOnError extends boolean = false>(options: Options<StoresApiCreateStoreData, ThrowOnError>) => (options.client ?? client).post<StoresApiCreateStoreResponses, StoresApiCreateStoreErrors, ThrowOnError>({
    url: '/api/v1/stores/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Store
 *
 * Delete a store.
 */
export const storesApiDeleteStore = <ThrowOnError extends boolean = false>(options: Options<StoresApiDeleteStoreData, ThrowOnError>) => (options.client ?? client).delete<StoresApiDeleteStoreResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/{store_id}', ...options });

/**
 * Get Store
 *
 * Retrieve a single store by ID.
 */
export const storesApiGetStore = <ThrowOnError extends boolean = false>(options: Options<StoresApiGetStoreData, ThrowOnError>) => (options.client ?? client).get<StoresApiGetStoreResponses, unknown, ThrowOnError>({ url: '/api/v1/stores/{store_id}', ...options });

/**
 * Update Store
 *
 * Partially update a store.
 */
export const storesApiUpdateStore = <ThrowOnError extends boolean = false>(options: Options<StoresApiUpdateStoreData, ThrowOnError>) => (options.client ?? client).patch<StoresApiUpdateStoreResponses, StoresApiUpdateStoreErrors, ThrowOnError>({
    url: '/api/v1/stores/{store_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Employee Stats
 */
export const employeesApiEmployeeStats = <ThrowOnError extends boolean = false>(options?: Options<EmployeesApiEmployeeStatsData, ThrowOnError>) => (options?.client ?? client).get<EmployeesApiEmployeeStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/employees/stats/', ...options });

/**
 * List Employment Types
 *
 * List selectable employment types for the employee create/edit form.
 */
export const employeesApiListEmploymentTypes = <ThrowOnError extends boolean = false>(options?: Options<EmployeesApiListEmploymentTypesData, ThrowOnError>) => (options?.client ?? client).get<EmployeesApiListEmploymentTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/employees/employment-types/', ...options });

/**
 * List Employee Roles
 *
 * List selectable employee roles for the employee create/edit form.
 */
export const employeesApiListEmployeeRoles = <ThrowOnError extends boolean = false>(options?: Options<EmployeesApiListEmployeeRolesData, ThrowOnError>) => (options?.client ?? client).get<EmployeesApiListEmployeeRolesResponses, unknown, ThrowOnError>({ url: '/api/v1/employees/roles/', ...options });

/**
 * List Employees
 */
export const employeesApiListEmployees = <ThrowOnError extends boolean = false>(options?: Options<EmployeesApiListEmployeesData, ThrowOnError>) => (options?.client ?? client).get<EmployeesApiListEmployeesResponses, unknown, ThrowOnError>({ url: '/api/v1/employees/', ...options });

/**
 * Create Employee
 */
export const employeesApiCreateEmployee = <ThrowOnError extends boolean = false>(options: Options<EmployeesApiCreateEmployeeData, ThrowOnError>) => (options.client ?? client).post<EmployeesApiCreateEmployeeResponses, EmployeesApiCreateEmployeeErrors, ThrowOnError>({
    url: '/api/v1/employees/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Employee
 */
export const employeesApiDeleteEmployee = <ThrowOnError extends boolean = false>(options: Options<EmployeesApiDeleteEmployeeData, ThrowOnError>) => (options.client ?? client).delete<EmployeesApiDeleteEmployeeResponses, EmployeesApiDeleteEmployeeErrors, ThrowOnError>({ url: '/api/v1/employees/{employee_id}', ...options });

/**
 * Get Employee
 */
export const employeesApiGetEmployee = <ThrowOnError extends boolean = false>(options: Options<EmployeesApiGetEmployeeData, ThrowOnError>) => (options.client ?? client).get<EmployeesApiGetEmployeeResponses, unknown, ThrowOnError>({ url: '/api/v1/employees/{employee_id}', ...options });

/**
 * Update Employee
 */
export const employeesApiUpdateEmployee = <ThrowOnError extends boolean = false>(options: Options<EmployeesApiUpdateEmployeeData, ThrowOnError>) => (options.client ?? client).patch<EmployeesApiUpdateEmployeeResponses, EmployeesApiUpdateEmployeeErrors, ThrowOnError>({
    url: '/api/v1/employees/{employee_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Work Item Bays
 */
export const mobileApiListWorkItemBays = <ThrowOnError extends boolean = false>(options: Options<MobileApiListWorkItemBaysData, ThrowOnError>) => (options.client ?? client).get<MobileApiListWorkItemBaysResponses, MobileApiListWorkItemBaysErrors, ThrowOnError>({ url: '/api/v1/mobile/work-items/{work_item_id}/bays/', ...options });

/**
 * Validate Work Order Location
 */
export const mobileApiValidateWorkOrderLocation = <ThrowOnError extends boolean = false>(options: Options<MobileApiValidateWorkOrderLocationData, ThrowOnError>) => (options.client ?? client).post<MobileApiValidateWorkOrderLocationResponses, MobileApiValidateWorkOrderLocationErrors, ThrowOnError>({
    url: '/api/v1/mobile/work-orders/{work_order_id}/validate-location',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Work Order Visit
 */
export const mobileApiStartWorkOrderVisit = <ThrowOnError extends boolean = false>(options: Options<MobileApiStartWorkOrderVisitData, ThrowOnError>) => (options.client ?? client).post<MobileApiStartWorkOrderVisitResponses, MobileApiStartWorkOrderVisitErrors, ThrowOnError>({
    url: '/api/v1/mobile/work-orders/{work_order_id}/start-visit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Work Order Nici Task
 */
export const mobileApiStartWorkOrderNiciTask = <ThrowOnError extends boolean = false>(options: Options<MobileApiStartWorkOrderNiciTaskData, ThrowOnError>) => (options.client ?? client).post<MobileApiStartWorkOrderNiciTaskResponses, MobileApiStartWorkOrderNiciTaskErrors, ThrowOnError>({
    url: '/api/v1/mobile/work-orders/{work_order_id}/nici/start-task',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Work Order Nici Scan
 */
export const mobileApiSubmitWorkOrderNiciScan = <ThrowOnError extends boolean = false>(options: Options<MobileApiSubmitWorkOrderNiciScanData, ThrowOnError>) => (options.client ?? client).post<MobileApiSubmitWorkOrderNiciScanResponses, MobileApiSubmitWorkOrderNiciScanErrors, ThrowOnError>({
    url: '/api/v1/mobile/work-orders/{work_order_id}/nici/scans/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop Work Order Nici Task
 */
export const mobileApiStopWorkOrderNiciTask = <ThrowOnError extends boolean = false>(options: Options<MobileApiStopWorkOrderNiciTaskData, ThrowOnError>) => (options.client ?? client).post<MobileApiStopWorkOrderNiciTaskResponses, MobileApiStopWorkOrderNiciTaskErrors, ThrowOnError>({
    url: '/api/v1/mobile/work-orders/{work_order_id}/nici/stop-task',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Work Item Task
 */
export const mobileApiStartWorkItemTask = <ThrowOnError extends boolean = false>(options: Options<MobileApiStartWorkItemTaskData, ThrowOnError>) => (options.client ?? client).post<MobileApiStartWorkItemTaskResponses, unknown, ThrowOnError>({
    url: '/api/v1/mobile/work-items/{work_item_id}/start-task',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Completion Summary
 */
export const mobileApiGetCompletionSummary = <ThrowOnError extends boolean = false>(options: Options<MobileApiGetCompletionSummaryData, ThrowOnError>) => (options.client ?? client).get<MobileApiGetCompletionSummaryResponses, MobileApiGetCompletionSummaryErrors, ThrowOnError>({ url: '/api/v1/mobile/work-items/{work_item_id}/completion-summary', ...options });

/**
 * Complete Work Item Task
 */
export const mobileApiCompleteWorkItemTask = <ThrowOnError extends boolean = false>(options: Options<MobileApiCompleteWorkItemTaskData, ThrowOnError>) => (options.client ?? client).post<MobileApiCompleteWorkItemTaskResponses, unknown, ThrowOnError>({
    url: '/api/v1/mobile/work-items/{work_item_id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Product Stats
 *
 * Return aggregated product statistics.
 *
 * Accepts the same filter params as the list endpoint so the
 * summary cards reflect the current filter state.
 *
 * Returns:
 * Dictionary with total SKU count, new-item count,
 * and distinct category count.
 */
export const productsProductsApiProductStats = <ThrowOnError extends boolean = false>(options?: Options<ProductsProductsApiProductStatsData, ThrowOnError>) => (options?.client ?? client).get<ProductsProductsApiProductStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/products/stats/', ...options });

/**
 * List Brands
 *
 * Return brands that have at least one product.
 */
export const productsProductsApiListBrands = <ThrowOnError extends boolean = false>(options?: Options<ProductsProductsApiListBrandsData, ThrowOnError>) => (options?.client ?? client).get<ProductsProductsApiListBrandsResponses, unknown, ThrowOnError>({ url: '/api/v1/products/brands/', ...options });

/**
 * List Products
 *
 * Return a paginated list of products.
 *
 * Args:
 * request: The incoming HTTP request.
 * search: Optional search term applied against barcode,
 * name, and brand.
 * category_id: Optional filter by category UUID.
 * brand_id: Optional filter by brand UUID.
 * page: Page number (1-indexed).
 * page_size: Number of items per page.
 *
 * Returns:
 * Paginated response with ``count``, ``next``, ``previous``,
 * and ``results`` keys.
 */
export const productsProductsApiListProducts = <ThrowOnError extends boolean = false>(options?: Options<ProductsProductsApiListProductsData, ThrowOnError>) => (options?.client ?? client).get<ProductsProductsApiListProductsResponses, unknown, ThrowOnError>({ url: '/api/v1/products/', ...options });

/**
 * Create Product
 *
 * Create a new product.
 *
 * Args:
 * request: The incoming HTTP request.
 * payload: Product data to create.
 *
 * Returns:
 * Tuple of ``(201, product)`` on success or
 * ``(409, error_dict)`` on integrity violation.
 */
export const productsProductsApiCreateProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiCreateProductData, ThrowOnError>) => (options.client ?? client).post<ProductsProductsApiCreateProductResponses, ProductsProductsApiCreateProductErrors, ThrowOnError>({
    url: '/api/v1/products/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Product
 *
 * Delete a product by ID.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to delete.
 *
 * Returns:
 * Tuple of ``(204, None)`` on successful deletion.
 */
export const productsProductsApiDeleteProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiDeleteProductData, ThrowOnError>) => (options.client ?? client).delete<ProductsProductsApiDeleteProductResponses, unknown, ThrowOnError>({ url: '/api/v1/products/{product_id}', ...options });

/**
 * Get Product
 *
 * Retrieve a single product by ID.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to retrieve.
 *
 * Returns:
 * The matching product instance.
 */
export const productsProductsApiGetProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiGetProductData, ThrowOnError>) => (options.client ?? client).get<ProductsProductsApiGetProductResponses, unknown, ThrowOnError>({ url: '/api/v1/products/{product_id}', ...options });

/**
 * Update Product
 *
 * Partially update a product.
 *
 * Only fields present in the request body are applied.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to update.
 * payload: Partial product data to apply.
 *
 * Returns:
 * Tuple of ``(200, product)`` on success or
 * ``(409, error_dict)`` on integrity violation.
 */
export const productsProductsApiUpdateProduct = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiUpdateProductData, ThrowOnError>) => (options.client ?? client).patch<ProductsProductsApiUpdateProductResponses, ProductsProductsApiUpdateProductErrors, ThrowOnError>({
    url: '/api/v1/products/{product_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Product Image
 *
 * Upload an image for a product.
 *
 * Validates file type (JPG/PNG), size (max 10 MB), and gallery
 * capacity (max 5 per product). The first uploaded image is set
 * as primary automatically.
 *
 * Args:
 * request: The incoming HTTP request.
 * product_id: UUID of the product to attach the image to.
 * file: Multipart file upload.
 *
 * Returns:
 * Tuple of ``(201, ProductImageOut)`` on success or
 * ``(400, error_dict)`` on validation failure.
 */
export const productsProductsApiUploadProductImage = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiUploadProductImageData, ThrowOnError>) => (options.client ?? client).post<ProductsProductsApiUploadProductImageResponses, ProductsProductsApiUploadProductImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/products/{product_id}/images/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Product Image
 *
 * Delete a single product image.
 *
 * Reorders remaining images so positions stay contiguous. If the
 * deleted image was primary, promotes the new position-0 image
 * to primary.
 *
 * Args:
 * request: The incoming HTTP request.
 * image_id: UUID of the image to delete.
 *
 * Returns:
 * Tuple of ``(204, None)`` on successful deletion.
 */
export const productsProductsApiDeleteProductImage = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiDeleteProductImageData, ThrowOnError>) => (options.client ?? client).delete<ProductsProductsApiDeleteProductImageResponses, unknown, ThrowOnError>({ url: '/api/v1/products/images/{image_id}/', ...options });

/**
 * Set Primary Product Image
 *
 * Promote an image to be the primary for its product.
 *
 * Clears the ``is_primary`` flag on any other image of the same
 * product, then sets it on the target image. Positions are
 * unchanged.
 *
 * Args:
 * request: The incoming HTTP request.
 * image_id: UUID of the image to promote.
 *
 * Returns:
 * Tuple of ``(200, ProductImageOut)`` for the promoted image.
 */
export const productsProductsApiSetPrimaryProductImage = <ThrowOnError extends boolean = false>(options: Options<ProductsProductsApiSetPrimaryProductImageData, ThrowOnError>) => (options.client ?? client).post<ProductsProductsApiSetPrimaryProductImageResponses, ProductsProductsApiSetPrimaryProductImageErrors, ThrowOnError>({ url: '/api/v1/products/images/{image_id}/set-primary/', ...options });

/**
 * Planogram Stats
 */
export const planogramsApiPlanogramsPlanogramStats = <ThrowOnError extends boolean = false>(options?: Options<PlanogramsApiPlanogramsPlanogramStatsData, ThrowOnError>) => (options?.client ?? client).get<PlanogramsApiPlanogramsPlanogramStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/stats/', ...options });

/**
 * List Planograms
 */
export const planogramsApiPlanogramsListPlanograms = <ThrowOnError extends boolean = false>(options?: Options<PlanogramsApiPlanogramsListPlanogramsData, ThrowOnError>) => (options?.client ?? client).get<PlanogramsApiPlanogramsListPlanogramsResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/', ...options });

/**
 * Create Planogram
 */
export const planogramsApiPlanogramsCreatePlanogram = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiPlanogramsCreatePlanogramData, ThrowOnError>) => (options.client ?? client).post<PlanogramsApiPlanogramsCreatePlanogramResponses, PlanogramsApiPlanogramsCreatePlanogramErrors, ThrowOnError>({
    url: '/api/v1/planograms/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Planogram
 */
export const planogramsApiPlanogramsDeletePlanogram = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiPlanogramsDeletePlanogramData, ThrowOnError>) => (options.client ?? client).delete<PlanogramsApiPlanogramsDeletePlanogramResponses, PlanogramsApiPlanogramsDeletePlanogramErrors, ThrowOnError>({ url: '/api/v1/planograms/{planogram_id}', ...options });

/**
 * Get Planogram
 */
export const planogramsApiPlanogramsGetPlanogram = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiPlanogramsGetPlanogramData, ThrowOnError>) => (options.client ?? client).get<PlanogramsApiPlanogramsGetPlanogramResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/{planogram_id}', ...options });

/**
 * Update Planogram
 */
export const planogramsApiPlanogramsUpdatePlanogram = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiPlanogramsUpdatePlanogramData, ThrowOnError>) => (options.client ?? client).patch<PlanogramsApiPlanogramsUpdatePlanogramResponses, PlanogramsApiPlanogramsUpdatePlanogramErrors, ThrowOnError>({
    url: '/api/v1/planograms/{planogram_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Planogram Details
 */
export const planogramsApiPlanogramsGetPlanogramDetails = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiPlanogramsGetPlanogramDetailsData, ThrowOnError>) => (options.client ?? client).get<PlanogramsApiPlanogramsGetPlanogramDetailsResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/{planogram_id}/details/', ...options });

/**
 * List Planogram Positions
 */
export const planogramsApiPositionsListPlanogramPositions = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiPositionsListPlanogramPositionsData, ThrowOnError>) => (options.client ?? client).get<PlanogramsApiPositionsListPlanogramPositionsResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/planogram-positions/', ...options });

/**
 * List Versions
 */
export const planogramsApiVersionsListVersions = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiVersionsListVersionsData, ThrowOnError>) => (options.client ?? client).get<PlanogramsApiVersionsListVersionsResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/planogram-versions/', ...options });

/**
 * Publish
 *
 * Publish a ready draft as an immutable Published Future version.
 *
 * Every failure carries its reason, because §11 asks the user to be
 * told why a publication was refused and given the chance to retry.
 */
export const planogramsApiVersionsPublish = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiVersionsPublishData, ThrowOnError>) => (options.client ?? client).post<PlanogramsApiVersionsPublishResponses, PlanogramsApiVersionsPublishErrors, ThrowOnError>({
    url: '/api/v1/planograms/planogram-versions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store Reach
 *
 * The stores a publish would affect, for the Publish Review step.
 *
 * Declared before ``/{version_id}`` so the literal path wins over the
 * UUID parameter.
 */
export const planogramsApiVersionsStoreReach = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiVersionsStoreReachData, ThrowOnError>) => (options.client ?? client).get<PlanogramsApiVersionsStoreReachResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/planogram-versions/store-reach/', ...options });

/**
 * Get Version
 */
export const planogramsApiVersionsGetVersion = <ThrowOnError extends boolean = false>(options: Options<PlanogramsApiVersionsGetVersionData, ThrowOnError>) => (options.client ?? client).get<PlanogramsApiVersionsGetVersionResponses, unknown, ThrowOnError>({ url: '/api/v1/planograms/planogram-versions/{version_id}', ...options });

/**
 * Get Visualization
 */
export const planogramsApiVisualizationGetVisualization = <ThrowOnError extends boolean = false>(options?: Options<PlanogramsApiVisualizationGetVisualizationData, ThrowOnError>) => (options?.client ?? client).get<PlanogramsApiVisualizationGetVisualizationResponses, PlanogramsApiVisualizationGetVisualizationErrors, ThrowOnError>({ url: '/api/v1/planograms/planogram-visualization/', ...options });

/**
 * Rule Stats
 *
 * Return aggregate policy rule statistics.
 */
export const rulesApiRuleStats = <ThrowOnError extends boolean = false>(options?: Options<RulesApiRuleStatsData, ThrowOnError>) => (options?.client ?? client).get<RulesApiRuleStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/rules/stats/', ...options });

/**
 * List Rules
 *
 * List policy rules with search, filtering, and pagination.
 */
export const rulesApiListRules = <ThrowOnError extends boolean = false>(options?: Options<RulesApiListRulesData, ThrowOnError>) => (options?.client ?? client).get<RulesApiListRulesResponses, unknown, ThrowOnError>({ url: '/api/v1/rules/', ...options });

/**
 * Create Rule
 *
 * Create a new policy rule.
 */
export const rulesApiCreateRule = <ThrowOnError extends boolean = false>(options: Options<RulesApiCreateRuleData, ThrowOnError>) => (options.client ?? client).post<RulesApiCreateRuleResponses, RulesApiCreateRuleErrors, ThrowOnError>({
    url: '/api/v1/rules/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Rule
 *
 * Delete a policy rule.
 */
export const rulesApiDeleteRule = <ThrowOnError extends boolean = false>(options: Options<RulesApiDeleteRuleData, ThrowOnError>) => (options.client ?? client).delete<RulesApiDeleteRuleResponses, unknown, ThrowOnError>({ url: '/api/v1/rules/{rule_id}', ...options });

/**
 * Get Rule
 *
 * Retrieve a single policy rule by ID.
 */
export const rulesApiGetRule = <ThrowOnError extends boolean = false>(options: Options<RulesApiGetRuleData, ThrowOnError>) => (options.client ?? client).get<RulesApiGetRuleResponses, unknown, ThrowOnError>({ url: '/api/v1/rules/{rule_id}', ...options });

/**
 * Update Rule
 *
 * Partially update a policy rule.
 */
export const rulesApiUpdateRule = <ThrowOnError extends boolean = false>(options: Options<RulesApiUpdateRuleData, ThrowOnError>) => (options.client ?? client).patch<RulesApiUpdateRuleResponses, RulesApiUpdateRuleErrors, ThrowOnError>({
    url: '/api/v1/rules/{rule_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Suppliers
 *
 * Return all suppliers ordered by name.
 */
export const suppliersApiListSuppliers = <ThrowOnError extends boolean = false>(options?: Options<SuppliersApiListSuppliersData, ThrowOnError>) => (options?.client ?? client).get<SuppliersApiListSuppliersResponses, unknown, ThrowOnError>({ url: '/api/v1/suppliers/', ...options });

/**
 * Store Category Stats
 */
export const mappingsApiStoreCategoriesStoreCategoryStats = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiStoreCategoriesStoreCategoryStatsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiStoreCategoriesStoreCategoryStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/store-categories/stats/', ...options });

/**
 * List Store Categories
 */
export const mappingsApiStoreCategoriesListStoreCategories = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiStoreCategoriesListStoreCategoriesData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiStoreCategoriesListStoreCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v1/store-categories/', ...options });

/**
 * Create Store Category
 */
export const mappingsApiStoreCategoriesCreateStoreCategory = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreCategoriesCreateStoreCategoryData, ThrowOnError>) => (options.client ?? client).post<MappingsApiStoreCategoriesCreateStoreCategoryResponses, MappingsApiStoreCategoriesCreateStoreCategoryErrors, ThrowOnError>({
    url: '/api/v1/store-categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Store Category
 */
export const mappingsApiStoreCategoriesDeleteStoreCategory = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreCategoriesDeleteStoreCategoryData, ThrowOnError>) => (options.client ?? client).delete<MappingsApiStoreCategoriesDeleteStoreCategoryResponses, unknown, ThrowOnError>({ url: '/api/v1/store-categories/{mapping_id}', ...options });

/**
 * Get Store Category
 */
export const mappingsApiStoreCategoriesGetStoreCategory = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreCategoriesGetStoreCategoryData, ThrowOnError>) => (options.client ?? client).get<MappingsApiStoreCategoriesGetStoreCategoryResponses, unknown, ThrowOnError>({ url: '/api/v1/store-categories/{mapping_id}', ...options });

/**
 * Update Store Category
 */
export const mappingsApiStoreCategoriesUpdateStoreCategory = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreCategoriesUpdateStoreCategoryData, ThrowOnError>) => (options.client ?? client).patch<MappingsApiStoreCategoriesUpdateStoreCategoryResponses, MappingsApiStoreCategoriesUpdateStoreCategoryErrors, ThrowOnError>({
    url: '/api/v1/store-categories/{mapping_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store Planogram Stats
 */
export const mappingsApiStorePlanogramsStorePlanogramStats = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiStorePlanogramsStorePlanogramStatsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiStorePlanogramsStorePlanogramStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/store-planograms/stats/', ...options });

/**
 * List Store Planograms
 */
export const mappingsApiStorePlanogramsListStorePlanograms = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiStorePlanogramsListStorePlanogramsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiStorePlanogramsListStorePlanogramsResponses, unknown, ThrowOnError>({ url: '/api/v1/store-planograms/', ...options });

/**
 * Create Store Planogram
 */
export const mappingsApiStorePlanogramsCreateStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStorePlanogramsCreateStorePlanogramData, ThrowOnError>) => (options.client ?? client).post<MappingsApiStorePlanogramsCreateStorePlanogramResponses, MappingsApiStorePlanogramsCreateStorePlanogramErrors, ThrowOnError>({
    url: '/api/v1/store-planograms/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Store Planogram
 */
export const mappingsApiStorePlanogramsDeleteStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStorePlanogramsDeleteStorePlanogramData, ThrowOnError>) => (options.client ?? client).delete<MappingsApiStorePlanogramsDeleteStorePlanogramResponses, MappingsApiStorePlanogramsDeleteStorePlanogramErrors, ThrowOnError>({ url: '/api/v1/store-planograms/{mapping_id}', ...options });

/**
 * Get Store Planogram
 */
export const mappingsApiStorePlanogramsGetStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStorePlanogramsGetStorePlanogramData, ThrowOnError>) => (options.client ?? client).get<MappingsApiStorePlanogramsGetStorePlanogramResponses, unknown, ThrowOnError>({ url: '/api/v1/store-planograms/{mapping_id}', ...options });

/**
 * Update Store Planogram
 */
export const mappingsApiStorePlanogramsUpdateStorePlanogram = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStorePlanogramsUpdateStorePlanogramData, ThrowOnError>) => (options.client ?? client).patch<MappingsApiStorePlanogramsUpdateStorePlanogramResponses, MappingsApiStorePlanogramsUpdateStorePlanogramErrors, ThrowOnError>({
    url: '/api/v1/store-planograms/{mapping_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Store Product Stats
 */
export const mappingsApiStoreProductsStoreProductStats = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiStoreProductsStoreProductStatsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiStoreProductsStoreProductStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/store-products/stats/', ...options });

/**
 * List Store Products
 */
export const mappingsApiStoreProductsListStoreProducts = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiStoreProductsListStoreProductsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiStoreProductsListStoreProductsResponses, unknown, ThrowOnError>({ url: '/api/v1/store-products/', ...options });

/**
 * Create Store Product
 */
export const mappingsApiStoreProductsCreateStoreProduct = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreProductsCreateStoreProductData, ThrowOnError>) => (options.client ?? client).post<MappingsApiStoreProductsCreateStoreProductResponses, MappingsApiStoreProductsCreateStoreProductErrors, ThrowOnError>({
    url: '/api/v1/store-products/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Store Product
 *
 * Deauthorize a listing.
 *
 * A soft delete since the assortment went soft-deletable, and for a
 * NEW listing it closes the NICI obligation as WITHDRAWN and
 * cancels the unfinished work against it. The endpoint itself does
 * nothing for that beyond calling ``delete()`` — the model's policy
 * and the receivers behind it carry the meaning.
 */
export const mappingsApiStoreProductsDeleteStoreProduct = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreProductsDeleteStoreProductData, ThrowOnError>) => (options.client ?? client).delete<MappingsApiStoreProductsDeleteStoreProductResponses, unknown, ThrowOnError>({ url: '/api/v1/store-products/{record_id}', ...options });

/**
 * Get Store Product
 */
export const mappingsApiStoreProductsGetStoreProduct = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreProductsGetStoreProductData, ThrowOnError>) => (options.client ?? client).get<MappingsApiStoreProductsGetStoreProductResponses, unknown, ThrowOnError>({ url: '/api/v1/store-products/{record_id}', ...options });

/**
 * Update Store Product
 */
export const mappingsApiStoreProductsUpdateStoreProduct = <ThrowOnError extends boolean = false>(options: Options<MappingsApiStoreProductsUpdateStoreProductData, ThrowOnError>) => (options.client ?? client).patch<MappingsApiStoreProductsUpdateStoreProductResponses, MappingsApiStoreProductsUpdateStoreProductErrors, ThrowOnError>({
    url: '/api/v1/store-products/{record_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Employee Store Assignments
 */
export const mappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignments = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiEmployeeStoreAssignmentsListEmployeeStoreAssignmentsResponses, unknown, ThrowOnError>({ url: '/api/v1/employee-store-assignments/', ...options });

/**
 * Create Employee Store Assignment
 */
export const mappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignment = <ThrowOnError extends boolean = false>(options: Options<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentData, ThrowOnError>) => (options.client ?? client).post<MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentResponses, MappingsApiEmployeeStoreAssignmentsCreateEmployeeStoreAssignmentErrors, ThrowOnError>({
    url: '/api/v1/employee-store-assignments/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Employee Store Assignment Stats
 */
export const mappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStats = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiEmployeeStoreAssignmentsEmployeeStoreAssignmentStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/employee-store-assignments/stats/', ...options });

/**
 * Get Employee Store Assignment
 */
export const mappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignment = <ThrowOnError extends boolean = false>(options: Options<MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentData, ThrowOnError>) => (options.client ?? client).get<MappingsApiEmployeeStoreAssignmentsGetEmployeeStoreAssignmentResponses, unknown, ThrowOnError>({ url: '/api/v1/employee-store-assignments/{assignment_id}', ...options });

/**
 * Update Employee Store Assignment
 */
export const mappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignment = <ThrowOnError extends boolean = false>(options: Options<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentData, ThrowOnError>) => (options.client ?? client).patch<MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentResponses, MappingsApiEmployeeStoreAssignmentsUpdateEmployeeStoreAssignmentErrors, ThrowOnError>({
    url: '/api/v1/employee-store-assignments/{assignment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Working Groups
 */
export const mappingsApiWorkingGroupsListWorkingGroups = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiWorkingGroupsListWorkingGroupsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiWorkingGroupsListWorkingGroupsResponses, unknown, ThrowOnError>({ url: '/api/v1/working-groups/', ...options });

/**
 * Create Working Group
 */
export const mappingsApiWorkingGroupsCreateWorkingGroup = <ThrowOnError extends boolean = false>(options: Options<MappingsApiWorkingGroupsCreateWorkingGroupData, ThrowOnError>) => (options.client ?? client).post<MappingsApiWorkingGroupsCreateWorkingGroupResponses, MappingsApiWorkingGroupsCreateWorkingGroupErrors, ThrowOnError>({
    url: '/api/v1/working-groups/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Working Group Stats
 */
export const mappingsApiWorkingGroupsWorkingGroupStats = <ThrowOnError extends boolean = false>(options?: Options<MappingsApiWorkingGroupsWorkingGroupStatsData, ThrowOnError>) => (options?.client ?? client).get<MappingsApiWorkingGroupsWorkingGroupStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/working-groups/stats/', ...options });

/**
 * Get Working Group
 */
export const mappingsApiWorkingGroupsGetWorkingGroup = <ThrowOnError extends boolean = false>(options: Options<MappingsApiWorkingGroupsGetWorkingGroupData, ThrowOnError>) => (options.client ?? client).get<MappingsApiWorkingGroupsGetWorkingGroupResponses, unknown, ThrowOnError>({ url: '/api/v1/working-groups/{group_id}', ...options });

/**
 * Update Working Group
 */
export const mappingsApiWorkingGroupsUpdateWorkingGroup = <ThrowOnError extends boolean = false>(options: Options<MappingsApiWorkingGroupsUpdateWorkingGroupData, ThrowOnError>) => (options.client ?? client).patch<MappingsApiWorkingGroupsUpdateWorkingGroupResponses, MappingsApiWorkingGroupsUpdateWorkingGroupErrors, ThrowOnError>({
    url: '/api/v1/working-groups/{group_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Cycle Stats
 */
export const planningApiResetCalendarResetCycleStats = <ThrowOnError extends boolean = false>(options?: Options<PlanningApiResetCalendarResetCycleStatsData, ThrowOnError>) => (options?.client ?? client).get<PlanningApiResetCalendarResetCycleStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/reset-calendar/stats/', ...options });

/**
 * List Reset Cycles
 */
export const planningApiResetCalendarListResetCycles = <ThrowOnError extends boolean = false>(options?: Options<PlanningApiResetCalendarListResetCyclesData, ThrowOnError>) => (options?.client ?? client).get<PlanningApiResetCalendarListResetCyclesResponses, unknown, ThrowOnError>({ url: '/api/v1/reset-calendar/', ...options });

/**
 * Create Reset Cycle
 */
export const planningApiResetCalendarCreateResetCycle = <ThrowOnError extends boolean = false>(options: Options<PlanningApiResetCalendarCreateResetCycleData, ThrowOnError>) => (options.client ?? client).post<PlanningApiResetCalendarCreateResetCycleResponses, PlanningApiResetCalendarCreateResetCycleErrors, ThrowOnError>({
    url: '/api/v1/reset-calendar/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Reset Cycle
 */
export const planningApiResetCalendarDeleteResetCycle = <ThrowOnError extends boolean = false>(options: Options<PlanningApiResetCalendarDeleteResetCycleData, ThrowOnError>) => (options.client ?? client).delete<PlanningApiResetCalendarDeleteResetCycleResponses, unknown, ThrowOnError>({ url: '/api/v1/reset-calendar/{cycle_id}', ...options });

/**
 * Get Reset Cycle
 */
export const planningApiResetCalendarGetResetCycle = <ThrowOnError extends boolean = false>(options: Options<PlanningApiResetCalendarGetResetCycleData, ThrowOnError>) => (options.client ?? client).get<PlanningApiResetCalendarGetResetCycleResponses, unknown, ThrowOnError>({ url: '/api/v1/reset-calendar/{cycle_id}', ...options });

/**
 * Update Reset Cycle
 */
export const planningApiResetCalendarUpdateResetCycle = <ThrowOnError extends boolean = false>(options: Options<PlanningApiResetCalendarUpdateResetCycleData, ThrowOnError>) => (options.client ?? client).patch<PlanningApiResetCalendarUpdateResetCycleResponses, PlanningApiResetCalendarUpdateResetCycleErrors, ThrowOnError>({
    url: '/api/v1/reset-calendar/{cycle_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nici Stats
 */
export const planningApiNiciNiciStats = <ThrowOnError extends boolean = false>(options?: Options<PlanningApiNiciNiciStatsData, ThrowOnError>) => (options?.client ?? client).get<PlanningApiNiciNiciStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/nici-schedules/stats/', ...options });

/**
 * List Nici
 */
export const planningApiNiciListNici = <ThrowOnError extends boolean = false>(options?: Options<PlanningApiNiciListNiciData, ThrowOnError>) => (options?.client ?? client).get<PlanningApiNiciListNiciResponses, PlanningApiNiciListNiciErrors, ThrowOnError>({ url: '/api/v1/nici-schedules/', ...options });

/**
 * Create Nici
 *
 * Bulk-create one listing per store in ``store_ids``.
 *
 * Overlap with an existing listing is reported per-store in ``conflicts``
 * rather than aborting the batch.
 */
export const planningApiNiciCreateNici = <ThrowOnError extends boolean = false>(options: Options<PlanningApiNiciCreateNiciData, ThrowOnError>) => (options.client ?? client).post<PlanningApiNiciCreateNiciResponses, PlanningApiNiciCreateNiciErrors, ThrowOnError>({
    url: '/api/v1/nici-schedules/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Nici
 *
 * Deauthorize a listing.
 *
 * A soft delete since the assortment went soft-deletable, and it
 * closes the listing's NICI obligation as WITHDRAWN and cancels
 * the unfinished work against it — which is what "the product is no
 * longer stocked here" has to mean operationally. The old 409 for a
 * listing with work items is gone: refusing was never the right
 * answer to "stop sending the crew", and ``PROTECT`` could not fire
 * any more anyway, the delete being an UPDATE now.
 */
export const planningApiNiciDeleteNici = <ThrowOnError extends boolean = false>(options: Options<PlanningApiNiciDeleteNiciData, ThrowOnError>) => (options.client ?? client).delete<PlanningApiNiciDeleteNiciResponses, unknown, ThrowOnError>({ url: '/api/v1/nici-schedules/{nici_id}', ...options });

/**
 * Get Nici
 */
export const planningApiNiciGetNici = <ThrowOnError extends boolean = false>(options: Options<PlanningApiNiciGetNiciData, ThrowOnError>) => (options.client ?? client).get<PlanningApiNiciGetNiciResponses, unknown, ThrowOnError>({ url: '/api/v1/nici-schedules/{nici_id}', ...options });

/**
 * Update Nici
 */
export const planningApiNiciUpdateNici = <ThrowOnError extends boolean = false>(options: Options<PlanningApiNiciUpdateNiciData, ThrowOnError>) => (options.client ?? client).patch<PlanningApiNiciUpdateNiciResponses, PlanningApiNiciUpdateNiciErrors, ThrowOnError>({
    url: '/api/v1/nici-schedules/{nici_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Upload
 *
 * Request a presigned upload form for direct file upload.
 */
export const storageApiRequestUpload = <ThrowOnError extends boolean = false>(options: Options<StorageApiRequestUploadData, ThrowOnError>) => (options.client ?? client).post<StorageApiRequestUploadResponses, unknown, ThrowOnError>({
    url: '/api/v1/storage/request-upload/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Local Fs Upload
 *
 * Receives files posted by ``LocalMediaStorage.presign_upload_form()``
 * when no S3 bucket is configured (local development).
 *
 * Validates size and SHA-256 checksum against the values baked into
 * the presigned form, then saves the file to ``default_storage`` at
 * the provided ``path``. Returns 204 on success, 400 on mismatch,
 * 404 when ``default_storage`` is not ``LocalMediaStorage`` (e.g. in
 * production where uploads go directly to S3).
 */
export const storageApiLocalFsUpload = <ThrowOnError extends boolean = false>(options: Options<StorageApiLocalFsUploadData, ThrowOnError>) => (options.client ?? client).post<StorageApiLocalFsUploadResponses, StorageApiLocalFsUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/storage/local-fs-upload/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Action Items
 */
export const complianceApiGetActionItems = <ThrowOnError extends boolean = false>(options?: Options<ComplianceApiGetActionItemsData, ThrowOnError>) => (options?.client ?? client).get<ComplianceApiGetActionItemsResponses, unknown, ThrowOnError>({ url: '/api/v1/compliance/action-items/', ...options });

/**
 * List Product Actions
 *
 * Return generated product actions for exactly one execution scope.
 *
 * A work-item scope keeps the RESET planogram behavior. A work-order
 * scope supports the informational discontinued-product list used by
 * NICI without changing product-action mutation behavior.
 *
 * Sorted by bay sequence, then display shelf number, then display
 * sequence — i.e. the natural reading order on the planogram.
 */
export const complianceApiListProductActions = <ThrowOnError extends boolean = false>(options?: Options<ComplianceApiListProductActionsData, ThrowOnError>) => (options?.client ?? client).get<ComplianceApiListProductActionsResponses, ComplianceApiListProductActionsErrors, ThrowOnError>({ url: '/api/v1/compliance/product-actions/', ...options });

/**
 * Get Product Actions Post Reset Photo State
 */
export const complianceApiGetProductActionsPostResetPhotoState = <ThrowOnError extends boolean = false>(options: Options<ComplianceApiGetProductActionsPostResetPhotoStateData, ThrowOnError>) => (options.client ?? client).get<ComplianceApiGetProductActionsPostResetPhotoStateResponses, ComplianceApiGetProductActionsPostResetPhotoStateErrors, ThrowOnError>({ url: '/api/v1/compliance/product-actions/post-reset-photo-state/', ...options });

/**
 * Update Product Action
 *
 * Set action_state to IDLE to undo a completion in the current active RESET task. The completion must be no more than five minutes old; submitted tasks cannot be changed.
 */
export const complianceApiUpdateProductAction = <ThrowOnError extends boolean = false>(options: Options<ComplianceApiUpdateProductActionData, ThrowOnError>) => (options.client ?? client).patch<ComplianceApiUpdateProductActionResponses, ComplianceApiUpdateProductActionErrors, ThrowOnError>({
    url: '/api/v1/compliance/product-actions/{product_action_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete Product Action
 *
 * Complete one product action. Use PERFORMED for the normal button and OOS_PRICE_TAG_PLACED only after the RESTOCK price-tag sheet is confirmed. Opening or cancelling that sheet sends no request. A 409 means the stored answer conflicts: reload the action and do not retry with a different outcome. Network retries must retain the original outcome. UI completion is action_state; its result label is completion_outcome. OOS remains status=MISSING and must not be returned as an unfinished task. After action reset, the backend cannot distinguish an old offline submission from a new command.
 */
export const complianceApiCompleteProductAction = <ThrowOnError extends boolean = false>(options: Options<ComplianceApiCompleteProductActionData, ThrowOnError>) => (options.client ?? client).post<ComplianceApiCompleteProductActionResponses, ComplianceApiCompleteProductActionErrors, ThrowOnError>({
    url: '/api/v1/compliance/product-actions/{product_action_id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Complete Product Actions
 */
export const complianceApiBulkCompleteProductActions = <ThrowOnError extends boolean = false>(options: Options<ComplianceApiBulkCompleteProductActionsData, ThrowOnError>) => (options.client ?? client).post<ComplianceApiBulkCompleteProductActionsResponses, ComplianceApiBulkCompleteProductActionsErrors, ThrowOnError>({
    url: '/api/v1/compliance/product-actions/bulk-complete/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Pog Category Rates
 *
 * POG compliance per category. Unmeasured categories are omitted.
 */
export const complianceApiListPogCategoryRates = <ThrowOnError extends boolean = false>(options?: Options<ComplianceApiListPogCategoryRatesData, ThrowOnError>) => (options?.client ?? client).get<ComplianceApiListPogCategoryRatesResponses, unknown, ThrowOnError>({ url: '/api/v1/compliance/pog-rates/categories/', ...options });

/**
 * Get Pog Category Rate
 */
export const complianceApiGetPogCategoryRate = <ThrowOnError extends boolean = false>(options: Options<ComplianceApiGetPogCategoryRateData, ThrowOnError>) => (options.client ?? client).get<ComplianceApiGetPogCategoryRateResponses, unknown, ThrowOnError>({ url: '/api/v1/compliance/pog-rates/categories/{category_id}', ...options });

/**
 * List Pog Store Rates
 *
 * Every store's latest compliance for one planogram.
 */
export const complianceApiListPogStoreRates = <ThrowOnError extends boolean = false>(options: Options<ComplianceApiListPogStoreRatesData, ThrowOnError>) => (options.client ?? client).get<ComplianceApiListPogStoreRatesResponses, unknown, ThrowOnError>({ url: '/api/v1/compliance/pog-rates/stores/', ...options });

/**
 * List Imports
 */
export const ingestionApiImportsListImports = <ThrowOnError extends boolean = false>(options?: Options<IngestionApiImportsListImportsData, ThrowOnError>) => (options?.client ?? client).get<IngestionApiImportsListImportsResponses, unknown, ThrowOnError>({ url: '/api/v1/imports/', ...options });

/**
 * Create Import
 */
export const ingestionApiImportsCreateImport = <ThrowOnError extends boolean = false>(options: Options<IngestionApiImportsCreateImportData, ThrowOnError>) => (options.client ?? client).post<IngestionApiImportsCreateImportResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/imports/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Approve Import
 */
export const ingestionApiImportsApproveImport = <ThrowOnError extends boolean = false>(options: Options<IngestionApiImportsApproveImportData, ThrowOnError>) => (options.client ?? client).post<IngestionApiImportsApproveImportResponses, IngestionApiImportsApproveImportErrors, ThrowOnError>({
    url: '/api/v1/imports/{import_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Imports Events Stream
 *
 * SSE stream for all import events (list view).
 */
export const ingestionApiImportsImportsEventsStream = <ThrowOnError extends boolean = false>(options?: Options<IngestionApiImportsImportsEventsStreamData, ThrowOnError>) => (options?.client ?? client).sse.get<IngestionApiImportsImportsEventsStreamResponses, unknown, ThrowOnError>({ url: '/api/v1/imports/events/', ...options });

/**
 * Get Import
 */
export const ingestionApiImportsGetImport = <ThrowOnError extends boolean = false>(options: Options<IngestionApiImportsGetImportData, ThrowOnError>) => (options.client ?? client).get<IngestionApiImportsGetImportResponses, unknown, ThrowOnError>({ url: '/api/v1/imports/{import_id}', ...options });

/**
 * List Import Errors
 */
export const ingestionApiImportsListImportErrors = <ThrowOnError extends boolean = false>(options: Options<IngestionApiImportsListImportErrorsData, ThrowOnError>) => (options.client ?? client).get<IngestionApiImportsListImportErrorsResponses, unknown, ThrowOnError>({ url: '/api/v1/imports/{import_id}/errors/', ...options });

/**
 * Download Import Errors Csv
 *
 * Stream a CSV report of the run's per-row errors, or of its
 * run-level failure when it has none.
 */
export const ingestionApiImportsDownloadImportErrorsCsv = <ThrowOnError extends boolean = false>(options: Options<IngestionApiImportsDownloadImportErrorsCsvData, ThrowOnError>) => (options.client ?? client).get<IngestionApiImportsDownloadImportErrorsCsvResponses, unknown, ThrowOnError>({ url: '/api/v1/imports/{import_id}/errors.csv', ...options });

/**
 * Import Events Stream
 *
 * SSE stream for a single import's progress.
 */
export const ingestionApiImportsImportEventsStream = <ThrowOnError extends boolean = false>(options: Options<IngestionApiImportsImportEventsStreamData, ThrowOnError>) => (options.client ?? client).sse.get<IngestionApiImportsImportEventsStreamResponses, unknown, ThrowOnError>({ url: '/api/v1/imports/{import_id}/events/', ...options });

/**
 * Connection Stats
 *
 * Return aggregate connection statistics.
 */
export const ingestionApiConnectionsConnectionStats = <ThrowOnError extends boolean = false>(options?: Options<IngestionApiConnectionsConnectionStatsData, ThrowOnError>) => (options?.client ?? client).get<IngestionApiConnectionsConnectionStatsResponses, unknown, ThrowOnError>({ url: '/api/v1/ai-connections/stats/', ...options });

/**
 * List Connections
 *
 * List connections with search, filtering, and pagination.
 */
export const ingestionApiConnectionsListConnections = <ThrowOnError extends boolean = false>(options?: Options<IngestionApiConnectionsListConnectionsData, ThrowOnError>) => (options?.client ?? client).get<IngestionApiConnectionsListConnectionsResponses, unknown, ThrowOnError>({ url: '/api/v1/ai-connections/', ...options });

/**
 * Create Connection
 *
 * Create a new connection.
 */
export const ingestionApiConnectionsCreateConnection = <ThrowOnError extends boolean = false>(options: Options<IngestionApiConnectionsCreateConnectionData, ThrowOnError>) => (options.client ?? client).post<IngestionApiConnectionsCreateConnectionResponses, IngestionApiConnectionsCreateConnectionErrors, ThrowOnError>({
    url: '/api/v1/ai-connections/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Connection
 *
 * Delete a connection.
 */
export const ingestionApiConnectionsDeleteConnection = <ThrowOnError extends boolean = false>(options: Options<IngestionApiConnectionsDeleteConnectionData, ThrowOnError>) => (options.client ?? client).delete<IngestionApiConnectionsDeleteConnectionResponses, unknown, ThrowOnError>({ url: '/api/v1/ai-connections/{connection_id}', ...options });

/**
 * Get Connection
 *
 * Retrieve a single connection by ID.
 */
export const ingestionApiConnectionsGetConnection = <ThrowOnError extends boolean = false>(options: Options<IngestionApiConnectionsGetConnectionData, ThrowOnError>) => (options.client ?? client).get<IngestionApiConnectionsGetConnectionResponses, unknown, ThrowOnError>({ url: '/api/v1/ai-connections/{connection_id}', ...options });

/**
 * Update Connection
 *
 * Partially update a connection.
 */
export const ingestionApiConnectionsUpdateConnection = <ThrowOnError extends boolean = false>(options: Options<IngestionApiConnectionsUpdateConnectionData, ThrowOnError>) => (options.client ?? client).patch<IngestionApiConnectionsUpdateConnectionResponses, IngestionApiConnectionsUpdateConnectionErrors, ThrowOnError>({
    url: '/api/v1/ai-connections/{connection_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Test Connection
 *
 * Test a connection (placeholder).
 */
export const ingestionApiConnectionsTestConnection = <ThrowOnError extends boolean = false>(options: Options<IngestionApiConnectionsTestConnectionData, ThrowOnError>) => (options.client ?? client).post<IngestionApiConnectionsTestConnectionResponses, IngestionApiConnectionsTestConnectionErrors, ThrowOnError>({ url: '/api/v1/ai-connections/{connection_id}/test/', ...options });

/**
 * Sync Connection
 *
 * Trigger a sync for a connection (placeholder).
 */
export const ingestionApiConnectionsSyncConnection = <ThrowOnError extends boolean = false>(options: Options<IngestionApiConnectionsSyncConnectionData, ThrowOnError>) => (options.client ?? client).post<IngestionApiConnectionsSyncConnectionResponses, IngestionApiConnectionsSyncConnectionErrors, ThrowOnError>({ url: '/api/v1/ai-connections/{connection_id}/sync/', ...options });

/**
 * Dashboard Summary
 */
export const projectsApiMissionControlDashboardSummary = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiMissionControlDashboardSummaryData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiMissionControlDashboardSummaryResponses, unknown, ThrowOnError>({ url: '/api/v1/mission-control/summary/', ...options });

/**
 * List Work Orders
 */
export const projectsApiMissionControlListWorkOrders = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiMissionControlListWorkOrdersData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiMissionControlListWorkOrdersResponses, ProjectsApiMissionControlListWorkOrdersErrors, ThrowOnError>({ url: '/api/v1/mission-control/work-orders/', ...options });

/**
 * List Alerts
 */
export const projectsApiMissionControlListAlerts = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiMissionControlListAlertsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiMissionControlListAlertsResponses, unknown, ThrowOnError>({ url: '/api/v1/mission-control/alerts/', ...options });

/**
 * List Escalations
 */
export const projectsApiMissionControlListEscalations = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiMissionControlListEscalationsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiMissionControlListEscalationsResponses, unknown, ThrowOnError>({ url: '/api/v1/mission-control/escalations/', ...options });

/**
 * Resolve Escalation
 */
export const projectsApiMissionControlResolveEscalation = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiMissionControlResolveEscalationData, ThrowOnError>) => (options.client ?? client).post<ProjectsApiMissionControlResolveEscalationResponses, ProjectsApiMissionControlResolveEscalationErrors, ThrowOnError>({
    url: '/api/v1/mission-control/escalations/{escalation_id}/actions/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Nici Project Summary
 */
export const projectsApiNiciTrackingNiciProjectSummary = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiNiciTrackingNiciProjectSummaryData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiNiciTrackingNiciProjectSummaryResponses, unknown, ThrowOnError>({ url: '/api/v1/mission-control/nici/projects/{project_id}/summary/', ...options });

/**
 * List Nici Stores
 */
export const projectsApiNiciTrackingListNiciStores = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiNiciTrackingListNiciStoresData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiNiciTrackingListNiciStoresResponses, ProjectsApiNiciTrackingListNiciStoresErrors, ThrowOnError>({ url: '/api/v1/mission-control/nici/projects/{project_id}/stores/', ...options });

/**
 * List Nici Items
 */
export const projectsApiNiciTrackingListNiciItems = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiNiciTrackingListNiciItemsData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiNiciTrackingListNiciItemsResponses, ProjectsApiNiciTrackingListNiciItemsErrors, ThrowOnError>({ url: '/api/v1/mission-control/nici/projects/{project_id}/items/', ...options });

/**
 * Nici Item Rollout
 */
export const projectsApiNiciTrackingNiciItemRollout = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiNiciTrackingNiciItemRolloutData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiNiciTrackingNiciItemRolloutResponses, ProjectsApiNiciTrackingNiciItemRolloutErrors, ThrowOnError>({ url: '/api/v1/mission-control/nici/projects/{project_id}/items/{product_id}/', ...options });

/**
 * List Assigned Stores
 */
export const projectsApiFieldworkListAssignedStores = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiFieldworkListAssignedStoresData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiFieldworkListAssignedStoresResponses, ProjectsApiFieldworkListAssignedStoresErrors, ThrowOnError>({ url: '/api/v1/fieldwork/stores/', ...options });

/**
 * Update Visit
 */
export const projectsApiFieldworkUpdateVisit = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiFieldworkUpdateVisitData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiFieldworkUpdateVisitResponses, ProjectsApiFieldworkUpdateVisitErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/fieldwork/visits/{visit_id}/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Visit Assignments
 */
export const projectsApiFieldworkListVisitAssignments = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiFieldworkListVisitAssignmentsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiFieldworkListVisitAssignmentsResponses, ProjectsApiFieldworkListVisitAssignmentsErrors, ThrowOnError>({ url: '/api/v1/fieldwork/visit-assignments/', ...options });

/**
 * Get Visit Assignment
 */
export const projectsApiFieldworkGetVisitAssignment = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiFieldworkGetVisitAssignmentData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiFieldworkGetVisitAssignmentResponses, ProjectsApiFieldworkGetVisitAssignmentErrors, ThrowOnError>({ url: '/api/v1/fieldwork/visit-assignments/{visit_assignment_id}/', ...options });

/**
 * Update Visit Assignment
 */
export const projectsApiFieldworkUpdateVisitAssignment = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiFieldworkUpdateVisitAssignmentData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiFieldworkUpdateVisitAssignmentResponses, ProjectsApiFieldworkUpdateVisitAssignmentErrors, ThrowOnError>({
    url: '/api/v1/fieldwork/visit-assignments/{visit_assignment_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Work Items
 */
export const projectsApiFieldworkListWorkItems = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiFieldworkListWorkItemsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiFieldworkListWorkItemsResponses, ProjectsApiFieldworkListWorkItemsErrors, ThrowOnError>({ url: '/api/v1/fieldwork/work-items/', ...options });

/**
 * List Timesheets
 */
export const projectsApiTimesheetsListTimesheets = <ThrowOnError extends boolean = false>(options?: Options<ProjectsApiTimesheetsListTimesheetsData, ThrowOnError>) => (options?.client ?? client).get<ProjectsApiTimesheetsListTimesheetsResponses, ProjectsApiTimesheetsListTimesheetsErrors, ThrowOnError>({ url: '/api/v1/fieldwork/timesheets/', ...options });

/**
 * Get Timesheet
 */
export const projectsApiTimesheetsGetTimesheet = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiTimesheetsGetTimesheetData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiTimesheetsGetTimesheetResponses, ProjectsApiTimesheetsGetTimesheetErrors, ThrowOnError>({ url: '/api/v1/fieldwork/timesheets/{timesheet_id}/', ...options });

/**
 * Update Timesheet
 *
 * End-of-day submit: corrections, break answers, and the transition.
 *
 * Closing the day is a transition of this resource, not a separate
 * endpoint — the same way a check-in is a transition of an assignment.
 * With ``?dry_run=true`` the whole pipeline runs and is rolled back,
 * and violations come back as a 200 preview rather than a rejection:
 * the client cannot compute the deduction itself, so only the server
 * can answer "what happens if I submit this".
 *
 * ``dry_run`` therefore discriminates the 200 body between
 * ``WorkdayTimesheetOut`` and ``DaySubmitPreviewOut``. OpenAPI cannot
 * say that — a response schema may not depend on a query parameter —
 * so the union is documented as ``anyOf`` and this docstring carries
 * the rule.
 */
export const projectsApiTimesheetsUpdateTimesheet = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiTimesheetsUpdateTimesheetData, ThrowOnError>) => (options.client ?? client).patch<ProjectsApiTimesheetsUpdateTimesheetResponses, ProjectsApiTimesheetsUpdateTimesheetErrors, ThrowOnError>({
    url: '/api/v1/fieldwork/timesheets/{timesheet_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Break Form
 *
 * The break questions for this day, as the server defines them.
 *
 * The form is server-owned: which questions apply, and what counts as
 * a valid answer, is policy — the client renders, it does not decide.
 *
 * ``no-store`` rather than a client-side convention: the form is built
 * from *this* day's gross minutes and the policy in force on its date,
 * so a reused copy asks the wrong questions and answers them against
 * the wrong day. ``no-store`` and not ``no-cache``, which permits a
 * stored copy and only forces revalidation — there is nothing here
 * worth keeping on disk between two openings of the screen.
 */
export const projectsApiTimesheetsGetBreakForm = <ThrowOnError extends boolean = false>(options: Options<ProjectsApiTimesheetsGetBreakFormData, ThrowOnError>) => (options.client ?? client).get<ProjectsApiTimesheetsGetBreakFormResponses, ProjectsApiTimesheetsGetBreakFormErrors, ThrowOnError>({ url: '/api/v1/fieldwork/timesheets/{timesheet_id}/break-form/', ...options });

/**
 * List Chats
 *
 * List chats: own for a user, all for an admin.
 */
export const supervisorApiListChats = <ThrowOnError extends boolean = false>(options?: Options<SupervisorApiListChatsData, ThrowOnError>) => (options?.client ?? client).get<SupervisorApiListChatsResponses, unknown, ThrowOnError>({ url: '/api/v1/supervisor/chats', ...options });

/**
 * Create Chat
 *
 * Create a chat and snapshot the (owned) work context.
 */
export const supervisorApiCreateChat = <ThrowOnError extends boolean = false>(options: Options<SupervisorApiCreateChatData, ThrowOnError>) => (options.client ?? client).post<SupervisorApiCreateChatResponses, SupervisorApiCreateChatErrors, ThrowOnError>({
    url: '/api/v1/supervisor/chats',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Messages
 *
 * Full transcript. Access: author or admin (ADMIN/ANALYST_READONLY).
 */
export const supervisorApiListMessages = <ThrowOnError extends boolean = false>(options: Options<SupervisorApiListMessagesData, ThrowOnError>) => (options.client ?? client).get<SupervisorApiListMessagesResponses, SupervisorApiListMessagesErrors, ThrowOnError>({ url: '/api/v1/supervisor/chats/{chat_id}/messages', ...options });

/**
 * Send Message
 *
 * Persist the question, then stream the answer (text/event-stream).
 *
 * Constance is read through ``aconfig`` — its async backend keeps the
 * cache-miss DB read off the event loop. The two-message create and the
 * concurrency slot stay on ``sync_to_async``: a sync ORM write would raise
 * ``SynchronousOnlyOperation`` from the loop.
 */
export const supervisorApiSendMessage = <ThrowOnError extends boolean = false>(options: Options<SupervisorApiSendMessageData, ThrowOnError>) => (options.client ?? client).post<SupervisorApiSendMessageResponses, SupervisorApiSendMessageErrors, ThrowOnError>({
    url: '/api/v1/supervisor/chats/{chat_id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
